require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.fill");

require("core-js/modules/es6.array.last-index-of");

require("core-js/modules/es6.typed.uint8-array");

require("core-js/modules/es6.date.to-json");

require("core-js/modules/es6.typed.uint32-array");

require("core-js/modules/es6.regexp.search");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.regexp.match");

require("core-js/modules/es6.string.trim");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

var _slicedToArray = require("/usr/local/src/gifts-frontend/node_modules/@babel/runtime/helpers/slicedToArray");

require("core-js/modules/es6.regexp.replace");

var _toConsumableArray = require("/usr/local/src/gifts-frontend/node_modules/@babel/runtime/helpers/toConsumableArray");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.regexp.constructor");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es7.string.pad-start");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.date.now");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.object.create");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e9) { throw _e9; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e10) { didErr = true; err = _e10; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.bitcoincomLink = e() : t.bitcoincomLink = e();
}("undefined" != typeof self ? self : this, function () {
  return function (t) {
    var e = {};

    function r(n) {
      if (e[n]) return e[n].exports;
      var o = e[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return t[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = t, r.c = e, r.d = function (t, e, n) {
      r.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, r.t = function (t, e) {
      if (1 & e && (t = r(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var o in t) {
        r.d(n, o, function (e) {
          return t[e];
        }.bind(null, o));
      }
      return n;
    }, r.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t["default"];
      } : function () {
        return t;
      };
      return r.d(e, "a", e), e;
    }, r.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, r.p = "", r(r.s = 8);
  }([function (t, e, r) {
    "use strict";

    var n;
    r.d(e, "a", function () {
      return n;
    }), r.d(e, "b", function () {
      return o;
    }), r.d(e, "c", function () {
      return i;
    }), r.d(e, "d", function () {
      return s;
    }), function (t) {
      t.getAddress = "getAddress", t.sendAssets = "sendAssets", t.payInvoice = "payInvoice", t.createToken = "createToken";
    }(n || (n = {}));
    var o = {
      type: "NO_PROVIDER",
      description: "Bitcoin.com Link provider not found."
    },
        i = {
      type: "REQUEST_TIMEOUT",
      description: "Provider is taking longer that timeout specified to complete request."
    };
    var s;
    !function (t) {
      t.NOT_AVAILABLE = "NOT_AVAILABLE", t.AVAILABLE = "AVAILABLE", t.LOGGED_IN = "LOGGED_IN";
    }(s || (s = {}));
  }, function (t, e, r) {
    "use strict";

    (function (t) {
      r.d(e, "d", function () {
        return a;
      }), r.d(e, "c", function () {
        return f;
      }), r.d(e, "a", function () {
        return c;
      }), r.d(e, "b", function () {
        return h;
      });
      var n = r(0),
          o = r(2);
      var i = {},
          s = "undefined" != typeof window,
          u = s ? window : t;

      function a(_ref) {
        var t = _ref.command,
            e = _ref.data,
            r = _ref.timeout;
        var u = t + (Date.now() + Math.random()).toString(),
            a = {
          messageId: u,
          command: t,
          data: e,
          websiteMetadata: Object(o.c)()
        };
        return new Promise(function (t, e) {
          var o, f, c, h, l, p;
          var d = s && (null === (f = null === (o = window) || void 0 === o ? void 0 : o._bitcoinWalletApi) || void 0 === f ? void 0 : f.messageHandler),
              g = s && (null === (p = null === (l = null === (h = null === (c = window) || void 0 === c ? void 0 : c.webkit) || void 0 === h ? void 0 : h.messageHandlers) || void 0 === l ? void 0 : l.sendMessageHandler) || void 0 === p ? void 0 : p.postMessage),
              m = Boolean(g) && "function" == typeof g;
          if (d) try {
            window._bitcoinWalletApi.messageHandler(JSON.stringify(a));
          } catch (t) {
            console.log("android error", t), e(n.b);
          } else if (m) try {
            window.webkit.messageHandlers.sendMessageHandler.postMessage(a);
          } catch (t) {
            console.log("ios error", t), e(n.b);
          }
          (d || g) && (i[u] = {
            resolve: t,
            reject: e,
            timeout: r && setTimeout(function () {
              delete i[u], e(n.c);
            }, r)
          });
        });
      }

      function f() {
        return Boolean(c() || h());
      }

      function c() {
        var t, e;
        return Boolean(s && (null === (e = null === (t = window) || void 0 === t ? void 0 : t._bitcoinWalletApi) || void 0 === e ? void 0 : e.messageHandler));
      }

      function h() {
        var t, e, r, n;
        var o = s && (null === (n = null === (r = null === (e = null === (t = window) || void 0 === t ? void 0 : t.webkit) || void 0 === e ? void 0 : e.messageHandlers) || void 0 === r ? void 0 : r.sendMessageHandler) || void 0 === n ? void 0 : n.postMessage);
        return Boolean(o) && "function" == typeof o;
      }

      u._bitcoinWalletApi = u._bitcoinWalletApi ? u._bitcoinWalletApi : {}, _bitcoinWalletApi.receiveMessage = function (t) {
        try {
          "string" == typeof t && (t = JSON.parse(t));
          var _t = t,
              _e = _t.messageId,
              _r = _t.data,
              _n = _t.error,
              _o = i[_e];

          if (_o) {
            var _t2 = _o.resolve,
                _e2 = _o.timeout,
                _i = _o.reject;
            _e2 && clearTimeout(_e2), _n ? _i(_n) : _t2(_r);
          }
        } catch (t) {}
      };
    }).call(this, r(5));
  }, function (t, e, r) {
    "use strict";

    (function (t) {
      r.d(e, "b", function () {
        return s;
      }), r.d(e, "a", function () {
        return u;
      }), r.d(e, "d", function () {
        return f;
      }), r.d(e, "c", function () {
        return l;
      });
      var n = r(4),
          o = r.n(n),
          i = r(3);

      function s(t, e) {
        return Number((Number(t) * Math.pow(10, e)).toString().split(".")[0]);
      }

      function u(e) {
        var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        var n;

        try {
          n = e.hash.toString("hex");
        } catch (t) {
          n = null;
        }

        return function (e, r, n, i, s, u, f) {
          var c = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 1;
          var h = [];
          h.push(106);
          var l = t.from("534c5000", "hex");
          if (h.push(a(l)), l.forEach(function (t) {
            return h.push(t);
          }), ![1, 65, 129].includes(c)) throw Error("Unable to create Genesis for this token type.");
          var p = c;
          h.push(a([p])), h.push(p);
          var d = t.from("GENESIS");
          if (h.push(a(d)), d.forEach(function (t) {
            return h.push(t);
          }), e && "string" != typeof e) throw Error("ticker must be a string");

          if (e && 0 !== e.length) {
            var _r2 = t.from(e, "utf8");

            h.push(a(_r2)), _r2.forEach(function (t) {
              return h.push(t);
            });
          } else [76, 0].forEach(function (t) {
            return h.push(t);
          });

          if (r && "string" != typeof r) throw Error("name must be a string");

          if (r && 0 !== r.length) {
            var _e3 = t.from(r, "utf8");

            h.push(a(_e3)), _e3.forEach(function (t) {
              return h.push(t);
            });
          } else [76, 0].forEach(function (t) {
            return h.push(t);
          });

          if (n && "string" != typeof n) throw Error("documentUri must be a string");

          if (n && 0 !== n.length) {
            var _e4 = t.from(n, "ascii");

            h.push(a(_e4)), _e4.forEach(function (t) {
              return h.push(t);
            });
          } else [76, 0].forEach(function (t) {
            return h.push(t);
          });

          if (i && 0 !== i.length) {
            if (64 !== i.length || !/^[0-9a-fA-F]+$/.test(i)) throw Error("Document hash must be provided as a 64 character hex string");
            {
              var _e5 = t.from(i, "hex");

              h.push(a(_e5)), _e5.forEach(function (t) {
                return h.push(t);
              });
            }
          } else [76, 0].forEach(function (t) {
            return h.push(t);
          });

          if (null == s || s < 0 || s > 9) throw Error("Decimals property must be in range 0 to 9");
          h.push(a([s])), h.push(s);
          if (null == u) [76, 0].forEach(function (t) {
            return h.push(t);
          });else {
            if (u < 2 || u > 255 || "number" != typeof u) throw Error("Baton vout must a number and greater than 1 and less than 256.");
            h.push(a([u])), h.push(u);
          }
          var g = new o.a("18446744073709551615");

          try {
            f.absoluteValue();
          } catch (t) {
            throw Error("Amount must be an instance of BigNumber");
          }

          if (f.isGreaterThan(g)) throw new Error("Maximum genesis value exceeded. Reduce input quantity below 18446744073709551615.");
          if (f.isLessThan(0)) throw Error("Genesis quantity must be greater than 0.");
          if (!f.modulo(1).isEqualTo(new o.a(0))) throw Error("Genesis quantity must be a whole number.");

          var m = function (e) {
            try {
              e.absoluteValue();
            } catch (t) {
              throw Error("Amount must be an instance of BigNumber");
            }

            var r = e.toString(16);
            return r = r.padStart(16, "0"), t.from(r, "hex");
          }(f);

          h.push(a(m)), m.forEach(function (t) {
            return h.push(t);
          });

          var y = function (e) {
            var r = e.reduce(function (t, e) {
              return Array.isArray(e) ? t + e.length : t + 1;
            }, 0),
                n = t.allocUnsafe(r);
            var o = 0;
            return e.forEach(function (t) {
              Array.isArray(t) ? t.forEach(function (t) {
                n.writeUInt8(t, o), o += 1;
              }) : (n.writeUInt8(t, o), o += 1);
            }), n;
          }(h);

          if (y.length > 223) throw Error("Script too long, must be less than 223 bytes.");
          return y;
        }(e.ticker, e.name, e.documentUri, n, e.decimals, e.batonVout, e.initialQuantity, r);
      }

      function a(t) {
        var e = t.length;
        if (0 === e) return [76, 0];
        if (e < 76) return e;
        if (e < 256) return [76, e];
        throw Error("Pushdata too large");
      }

      function f(t) {
        return new RegExp("^(simpleledger:|slptest:|slpreg:)?(q|p)[a-z0-9]{41}$").test(t);
      }

      var c = Object.assign(Object.assign({}, i.metadataRuleSets.description), {
        rules: [].concat(_toConsumableArray(i.metadataRuleSets.description.rules), [['meta[name="twitter:description"]', function (t) {
          return t.getAttribute("content");
        }], ['meta[property="twitter:description"]', function (t) {
          return t.getAttribute("content");
        }], ['meta[itemprop="description"]', function (t) {
          return t.getAttribute("content");
        }], ["description", function (t) {
          return t.text;
        }]])
      }),
          h = Object.assign(Object.assign({}, i.metadataRuleSets.image), {
        rules: [].concat(_toConsumableArray(i.metadataRuleSets.image.rules), [['meta[name="twitter:image:src"]', function (t) {
          return t.getAttribute("content");
        }], ['meta[property="twitter:image:src"]', function (t) {
          return t.getAttribute("content");
        }], ['meta[name="image"]', function (t) {
          return t.getAttribute("content");
        }], ['meta[itemprop="image"]', function (t) {
          return t.getAttribute("content");
        }]])
      });

      function l() {
        var t, e;
        var r = null === (t = window) || void 0 === t ? void 0 : t.location,
            n = null === (e = window) || void 0 === e ? void 0 : e.document;
        return Object(i.getMetadata)(n, r, {
          title: i.metadataRuleSets.title,
          description: c,
          image: h
        });
      }
    }).call(this, r(6).Buffer);
  }, function (t, e, r) {
    var _r3 = r(12),
        n = _r3.makeUrlAbsolute,
        o = _r3.parseUrl;

    function i(t) {
      return t.replace(/www[a-zA-Z0-9]*\./, "").replace(".co.", ".").split(".").slice(0, -1).join(" ");
    }

    function s(t) {
      return function (e, r) {
        var n,
            o = 0;

        for (var _r4 = 0; _r4 < t.rules.length; _r4++) {
          var _t$rules$_r = _slicedToArray(t.rules[_r4], 2),
              _i2 = _t$rules$_r[0],
              _s = _t$rules$_r[1],
              _u = Array.from(e.querySelectorAll(_i2));

          if (_u.length) {
            var _iterator = _createForOfIteratorHelper(_u),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var _e6 = _step.value;

                var _i3 = t.rules.length - _r4;

                if (t.scorers) {
                  var _iterator2 = _createForOfIteratorHelper(t.scorers),
                      _step2;

                  try {
                    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                      var _r5 = _step2.value;

                      var _t3 = _r5(_e6, _i3);

                      _t3 && (_i3 = _t3);
                    }
                  } catch (err) {
                    _iterator2.e(err);
                  } finally {
                    _iterator2.f();
                  }
                }

                _i3 > o && (o = _i3, n = _s(_e6));
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          }
        }

        if (!n && t.defaultValue && (n = t.defaultValue(r)), n) {
          if (t.processors) {
            var _iterator3 = _createForOfIteratorHelper(t.processors),
                _step3;

            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var _e7 = _step3.value;
                n = _e7(n, r);
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
          }

          return n.trim && (n = n.trim()), n;
        }
      };
    }

    var u = {
      description: {
        rules: [['meta[property="og:description"]', function (t) {
          return t.getAttribute("content");
        }], ['meta[name="description" i]', function (t) {
          return t.getAttribute("content");
        }]]
      },
      icon: {
        rules: [['link[rel="apple-touch-icon"]', function (t) {
          return t.getAttribute("href");
        }], ['link[rel="apple-touch-icon-precomposed"]', function (t) {
          return t.getAttribute("href");
        }], ['link[rel="icon" i]', function (t) {
          return t.getAttribute("href");
        }], ['link[rel="fluid-icon"]', function (t) {
          return t.getAttribute("href");
        }], ['link[rel="shortcut icon"]', function (t) {
          return t.getAttribute("href");
        }], ['link[rel="Shortcut Icon"]', function (t) {
          return t.getAttribute("href");
        }], ['link[rel="mask-icon"]', function (t) {
          return t.getAttribute("href");
        }]],
        scorers: [function (t, e) {
          var r = t.getAttribute("sizes");

          if (r) {
            var _t4 = r.match(/\d+/g);

            if (_t4) return _t4[0];
          }
        }],
        defaultValue: function defaultValue(t) {
          return "favicon.ico";
        },
        processors: [function (t, e) {
          return n(e.url, t);
        }]
      },
      image: {
        rules: [['meta[property="og:image:secure_url"]', function (t) {
          return t.getAttribute("content");
        }], ['meta[property="og:image:url"]', function (t) {
          return t.getAttribute("content");
        }], ['meta[property="og:image"]', function (t) {
          return t.getAttribute("content");
        }], ['meta[name="twitter:image"]', function (t) {
          return t.getAttribute("content");
        }], ['meta[property="twitter:image"]', function (t) {
          return t.getAttribute("content");
        }], ['meta[name="thumbnail"]', function (t) {
          return t.getAttribute("content");
        }]],
        processors: [function (t, e) {
          return n(e.url, t);
        }]
      },
      keywords: {
        rules: [['meta[name="keywords" i]', function (t) {
          return t.getAttribute("content");
        }]],
        processors: [function (t, e) {
          return t.split(",").map(function (t) {
            return t.trim();
          });
        }]
      },
      title: {
        rules: [['meta[property="og:title"]', function (t) {
          return t.getAttribute("content");
        }], ['meta[name="twitter:title"]', function (t) {
          return t.getAttribute("content");
        }], ['meta[property="twitter:title"]', function (t) {
          return t.getAttribute("content");
        }], ['meta[name="hdl"]', function (t) {
          return t.getAttribute("content");
        }], ["title", function (t) {
          return t.text;
        }]]
      },
      language: {
        rules: [["html[lang]", function (t) {
          return t.getAttribute("lang");
        }], ['meta[name="language" i]', function (t) {
          return t.getAttribute("content");
        }]],
        processors: [function (t, e) {
          return t.split("-")[0];
        }]
      },
      type: {
        rules: [['meta[property="og:type"]', function (t) {
          return t.getAttribute("content");
        }]]
      },
      url: {
        rules: [["a.amp-canurl", function (t) {
          return t.getAttribute("href");
        }], ['link[rel="canonical"]', function (t) {
          return t.getAttribute("href");
        }], ['meta[property="og:url"]', function (t) {
          return t.getAttribute("content");
        }]],
        defaultValue: function defaultValue(t) {
          return t.url;
        },
        processors: [function (t, e) {
          return n(e.url, t);
        }]
      },
      provider: {
        rules: [['meta[property="og:site_name"]', function (t) {
          return t.getAttribute("content");
        }]],
        defaultValue: function defaultValue(t) {
          return i(o(t.url));
        }
      }
    };
    t.exports = {
      buildRuleSet: s,
      getMetadata: function getMetadata(t, e, r) {
        var n = {},
            o = {
          url: e
        },
            i = r || u;
        return Object.keys(i).map(function (e) {
          var r = s(i[e]);
          n[e] = r(t, o);
        }), n;
      },
      getProvider: i,
      metadataRuleSets: u
    };
  }, function (t, e, r) {
    var n;
    !function (o) {
      "use strict";

      var i,
          s = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i,
          u = Math.ceil,
          a = Math.floor,
          f = "[BigNumber Error] ",
          c = f + "Number primitive has more than 15 significant digits: ",
          h = 1e14,
          l = 14,
          p = 9007199254740991,
          d = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13],
          g = 1e7,
          m = 1e9;

      function y(t) {
        var e = 0 | t;
        return t > 0 || t === e ? e : e - 1;
      }

      function b(t) {
        for (var e, r, n = 1, o = t.length, i = t[0] + ""; n < o;) {
          for (e = t[n++] + "", r = l - e.length; r--; e = "0" + e) {
            ;
          }

          i += e;
        }

        for (o = i.length; 48 === i.charCodeAt(--o);) {
          ;
        }

        return i.slice(0, o + 1 || 1);
      }

      function w(t, e) {
        var r,
            n,
            o = t.c,
            i = e.c,
            s = t.s,
            u = e.s,
            a = t.e,
            f = e.e;
        if (!s || !u) return null;
        if (r = o && !o[0], n = i && !i[0], r || n) return r ? n ? 0 : -u : s;
        if (s != u) return s;
        if (r = s < 0, n = a == f, !o || !i) return n ? 0 : !o ^ r ? 1 : -1;
        if (!n) return a > f ^ r ? 1 : -1;

        for (u = (a = o.length) < (f = i.length) ? a : f, s = 0; s < u; s++) {
          if (o[s] != i[s]) return o[s] > i[s] ^ r ? 1 : -1;
        }

        return a == f ? 0 : a > f ^ r ? 1 : -1;
      }

      function v(t, e, r, n) {
        if (t < e || t > r || t !== a(t)) throw Error(f + (n || "Argument") + ("number" == typeof t ? t < e || t > r ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(t));
      }

      function A(t) {
        var e = t.c.length - 1;
        return y(t.e / l) == e && t.c[e] % 2 != 0;
      }

      function E(t, e) {
        return (t.length > 1 ? t.charAt(0) + "." + t.slice(1) : t) + (e < 0 ? "e" : "e+") + e;
      }

      function O(t, e, r) {
        var n, o;

        if (e < 0) {
          for (o = r + "."; ++e; o += r) {
            ;
          }

          t = o + t;
        } else if (++e > (n = t.length)) {
          for (o = r, e -= n; --e; o += r) {
            ;
          }

          t += o;
        } else e < n && (t = t.slice(0, e) + "." + t.slice(e));

        return t;
      }

      (i = function t(e) {
        var r,
            n,
            o,
            i,
            R,
            P,
            _,
            B,
            S,
            T = V.prototype = {
          constructor: V,
          toString: null,
          valueOf: null
        },
            I = new V(1),
            U = 20,
            N = 4,
            L = -7,
            x = 21,
            C = -1e7,
            j = 1e7,
            k = !1,
            M = 1,
            D = 0,
            Y = {
          prefix: "",
          groupSize: 3,
          secondaryGroupSize: 0,
          groupSeparator: ",",
          decimalSeparator: ".",
          fractionGroupSize: 0,
          fractionGroupSeparator: " ",
          suffix: ""
        },
            q = "0123456789abcdefghijklmnopqrstuvwxyz";

        function V(t, e) {
          var r,
              i,
              u,
              f,
              h,
              d,
              g,
              m,
              y = this;
          if (!(y instanceof V)) return new V(t, e);

          if (null == e) {
            if (t && !0 === t._isBigNumber) return y.s = t.s, void (!t.c || t.e > j ? y.c = y.e = null : t.e < C ? y.c = [y.e = 0] : (y.e = t.e, y.c = t.c.slice()));

            if ((d = "number" == typeof t) && 0 * t == 0) {
              if (y.s = 1 / t < 0 ? (t = -t, -1) : 1, t === ~~t) {
                for (f = 0, h = t; h >= 10; h /= 10, f++) {
                  ;
                }

                return void (f > j ? y.c = y.e = null : (y.e = f, y.c = [t]));
              }

              m = String(t);
            } else {
              if (!s.test(m = String(t))) return o(y, m, d);
              y.s = 45 == m.charCodeAt(0) ? (m = m.slice(1), -1) : 1;
            }

            (f = m.indexOf(".")) > -1 && (m = m.replace(".", "")), (h = m.search(/e/i)) > 0 ? (f < 0 && (f = h), f += +m.slice(h + 1), m = m.substring(0, h)) : f < 0 && (f = m.length);
          } else {
            if (v(e, 2, q.length, "Base"), 10 == e) return z(y = new V(t), U + y.e + 1, N);

            if (m = String(t), d = "number" == typeof t) {
              if (0 * t != 0) return o(y, m, d, e);
              if (y.s = 1 / t < 0 ? (m = m.slice(1), -1) : 1, V.DEBUG && m.replace(/^0\.0*|\./, "").length > 15) throw Error(c + t);
            } else y.s = 45 === m.charCodeAt(0) ? (m = m.slice(1), -1) : 1;

            for (r = q.slice(0, e), f = h = 0, g = m.length; h < g; h++) {
              if (r.indexOf(i = m.charAt(h)) < 0) {
                if ("." == i) {
                  if (h > f) {
                    f = g;
                    continue;
                  }
                } else if (!u && (m == m.toUpperCase() && (m = m.toLowerCase()) || m == m.toLowerCase() && (m = m.toUpperCase()))) {
                  u = !0, h = -1, f = 0;
                  continue;
                }

                return o(y, String(t), d, e);
              }
            }

            d = !1, (f = (m = n(m, e, 10, y.s)).indexOf(".")) > -1 ? m = m.replace(".", "") : f = m.length;
          }

          for (h = 0; 48 === m.charCodeAt(h); h++) {
            ;
          }

          for (g = m.length; 48 === m.charCodeAt(--g);) {
            ;
          }

          if (m = m.slice(h, ++g)) {
            if (g -= h, d && V.DEBUG && g > 15 && (t > p || t !== a(t))) throw Error(c + y.s * t);
            if ((f = f - h - 1) > j) y.c = y.e = null;else if (f < C) y.c = [y.e = 0];else {
              if (y.e = f, y.c = [], h = (f + 1) % l, f < 0 && (h += l), h < g) {
                for (h && y.c.push(+m.slice(0, h)), g -= l; h < g;) {
                  y.c.push(+m.slice(h, h += l));
                }

                h = l - (m = m.slice(h)).length;
              } else h -= g;

              for (; h--; m += "0") {
                ;
              }

              y.c.push(+m);
            }
          } else y.c = [y.e = 0];
        }

        function F(t, e, r, n) {
          var o, i, s, u, a;
          if (null == r ? r = N : v(r, 0, 8), !t.c) return t.toString();
          if (o = t.c[0], s = t.e, null == e) a = b(t.c), a = 1 == n || 2 == n && (s <= L || s >= x) ? E(a, s) : O(a, s, "0");else if (i = (t = z(new V(t), e, r)).e, u = (a = b(t.c)).length, 1 == n || 2 == n && (e <= i || i <= L)) {
            for (; u < e; a += "0", u++) {
              ;
            }

            a = E(a, i);
          } else if (e -= s, a = O(a, i, "0"), i + 1 > u) {
            if (--e > 0) for (a += "."; e--; a += "0") {
              ;
            }
          } else if ((e += i - u) > 0) for (i + 1 == u && (a += "."); e--; a += "0") {
            ;
          }
          return t.s < 0 && o ? "-" + a : a;
        }

        function H(t, e) {
          for (var r, n = 1, o = new V(t[0]); n < t.length; n++) {
            if (!(r = new V(t[n])).s) {
              o = r;
              break;
            }

            e.call(o, r) && (o = r);
          }

          return o;
        }

        function G(t, e, r) {
          for (var n = 1, o = e.length; !e[--o]; e.pop()) {
            ;
          }

          for (o = e[0]; o >= 10; o /= 10, n++) {
            ;
          }

          return (r = n + r * l - 1) > j ? t.c = t.e = null : r < C ? t.c = [t.e = 0] : (t.e = r, t.c = e), t;
        }

        function z(t, e, r, n) {
          var o,
              i,
              s,
              f,
              c,
              p,
              g,
              m = t.c,
              y = d;

          if (m) {
            t: {
              for (o = 1, f = m[0]; f >= 10; f /= 10, o++) {
                ;
              }

              if ((i = e - o) < 0) i += l, s = e, g = (c = m[p = 0]) / y[o - s - 1] % 10 | 0;else if ((p = u((i + 1) / l)) >= m.length) {
                if (!n) break t;

                for (; m.length <= p; m.push(0)) {
                  ;
                }

                c = g = 0, o = 1, s = (i %= l) - l + 1;
              } else {
                for (c = f = m[p], o = 1; f >= 10; f /= 10, o++) {
                  ;
                }

                g = (s = (i %= l) - l + o) < 0 ? 0 : c / y[o - s - 1] % 10 | 0;
              }
              if (n = n || e < 0 || null != m[p + 1] || (s < 0 ? c : c % y[o - s - 1]), n = r < 4 ? (g || n) && (0 == r || r == (t.s < 0 ? 3 : 2)) : g > 5 || 5 == g && (4 == r || n || 6 == r && (i > 0 ? s > 0 ? c / y[o - s] : 0 : m[p - 1]) % 10 & 1 || r == (t.s < 0 ? 8 : 7)), e < 1 || !m[0]) return m.length = 0, n ? (e -= t.e + 1, m[0] = y[(l - e % l) % l], t.e = -e || 0) : m[0] = t.e = 0, t;
              if (0 == i ? (m.length = p, f = 1, p--) : (m.length = p + 1, f = y[l - i], m[p] = s > 0 ? a(c / y[o - s] % y[s]) * f : 0), n) for (;;) {
                if (0 == p) {
                  for (i = 1, s = m[0]; s >= 10; s /= 10, i++) {
                    ;
                  }

                  for (s = m[0] += f, f = 1; s >= 10; s /= 10, f++) {
                    ;
                  }

                  i != f && (t.e++, m[0] == h && (m[0] = 1));
                  break;
                }

                if (m[p] += f, m[p] != h) break;
                m[p--] = 0, f = 1;
              }

              for (i = m.length; 0 === m[--i]; m.pop()) {
                ;
              }
            }

            t.e > j ? t.c = t.e = null : t.e < C && (t.c = [t.e = 0]);
          }

          return t;
        }

        function W(t) {
          var e,
              r = t.e;
          return null === r ? t.toString() : (e = b(t.c), e = r <= L || r >= x ? E(e, r) : O(e, r, "0"), t.s < 0 ? "-" + e : e);
        }

        return V.clone = t, V.ROUND_UP = 0, V.ROUND_DOWN = 1, V.ROUND_CEIL = 2, V.ROUND_FLOOR = 3, V.ROUND_HALF_UP = 4, V.ROUND_HALF_DOWN = 5, V.ROUND_HALF_EVEN = 6, V.ROUND_HALF_CEIL = 7, V.ROUND_HALF_FLOOR = 8, V.EUCLID = 9, V.config = V.set = function (t) {
          var e, r;

          if (null != t) {
            if ("object" != typeof t) throw Error(f + "Object expected: " + t);
            if (t.hasOwnProperty(e = "DECIMAL_PLACES") && (v(r = t[e], 0, m, e), U = r), t.hasOwnProperty(e = "ROUNDING_MODE") && (v(r = t[e], 0, 8, e), N = r), t.hasOwnProperty(e = "EXPONENTIAL_AT") && ((r = t[e]) && r.pop ? (v(r[0], -m, 0, e), v(r[1], 0, m, e), L = r[0], x = r[1]) : (v(r, -m, m, e), L = -(x = r < 0 ? -r : r))), t.hasOwnProperty(e = "RANGE")) if ((r = t[e]) && r.pop) v(r[0], -m, -1, e), v(r[1], 1, m, e), C = r[0], j = r[1];else {
              if (v(r, -m, m, e), !r) throw Error(f + e + " cannot be zero: " + r);
              C = -(j = r < 0 ? -r : r);
            }

            if (t.hasOwnProperty(e = "CRYPTO")) {
              if ((r = t[e]) !== !!r) throw Error(f + e + " not true or false: " + r);

              if (r) {
                if ("undefined" == typeof crypto || !crypto || !crypto.getRandomValues && !crypto.randomBytes) throw k = !r, Error(f + "crypto unavailable");
                k = r;
              } else k = r;
            }

            if (t.hasOwnProperty(e = "MODULO_MODE") && (v(r = t[e], 0, 9, e), M = r), t.hasOwnProperty(e = "POW_PRECISION") && (v(r = t[e], 0, m, e), D = r), t.hasOwnProperty(e = "FORMAT")) {
              if ("object" != typeof (r = t[e])) throw Error(f + e + " not an object: " + r);
              Y = r;
            }

            if (t.hasOwnProperty(e = "ALPHABET")) {
              if ("string" != typeof (r = t[e]) || /^.$|[+-.\s]|(.).*\1/.test(r)) throw Error(f + e + " invalid: " + r);
              q = r;
            }
          }

          return {
            DECIMAL_PLACES: U,
            ROUNDING_MODE: N,
            EXPONENTIAL_AT: [L, x],
            RANGE: [C, j],
            CRYPTO: k,
            MODULO_MODE: M,
            POW_PRECISION: D,
            FORMAT: Y,
            ALPHABET: q
          };
        }, V.isBigNumber = function (t) {
          if (!t || !0 !== t._isBigNumber) return !1;
          if (!V.DEBUG) return !0;
          var e,
              r,
              n = t.c,
              o = t.e,
              i = t.s;

          t: if ("[object Array]" == {}.toString.call(n)) {
            if ((1 === i || -1 === i) && o >= -m && o <= m && o === a(o)) {
              if (0 === n[0]) {
                if (0 === o && 1 === n.length) return !0;
                break t;
              }

              if ((e = (o + 1) % l) < 1 && (e += l), String(n[0]).length == e) {
                for (e = 0; e < n.length; e++) {
                  if ((r = n[e]) < 0 || r >= h || r !== a(r)) break t;
                }

                if (0 !== r) return !0;
              }
            }
          } else if (null === n && null === o && (null === i || 1 === i || -1 === i)) return !0;

          throw Error(f + "Invalid BigNumber: " + t);
        }, V.maximum = V.max = function () {
          return H(arguments, T.lt);
        }, V.minimum = V.min = function () {
          return H(arguments, T.gt);
        }, V.random = (i = 9007199254740992 * Math.random() & 2097151 ? function () {
          return a(9007199254740992 * Math.random());
        } : function () {
          return 8388608 * (1073741824 * Math.random() | 0) + (8388608 * Math.random() | 0);
        }, function (t) {
          var e,
              r,
              n,
              o,
              s,
              c = 0,
              h = [],
              p = new V(I);
          if (null == t ? t = U : v(t, 0, m), o = u(t / l), k) if (crypto.getRandomValues) {
            for (e = crypto.getRandomValues(new Uint32Array(o *= 2)); c < o;) {
              (s = 131072 * e[c] + (e[c + 1] >>> 11)) >= 9e15 ? (r = crypto.getRandomValues(new Uint32Array(2)), e[c] = r[0], e[c + 1] = r[1]) : (h.push(s % 1e14), c += 2);
            }

            c = o / 2;
          } else {
            if (!crypto.randomBytes) throw k = !1, Error(f + "crypto unavailable");

            for (e = crypto.randomBytes(o *= 7); c < o;) {
              (s = 281474976710656 * (31 & e[c]) + 1099511627776 * e[c + 1] + 4294967296 * e[c + 2] + 16777216 * e[c + 3] + (e[c + 4] << 16) + (e[c + 5] << 8) + e[c + 6]) >= 9e15 ? crypto.randomBytes(7).copy(e, c) : (h.push(s % 1e14), c += 7);
            }

            c = o / 7;
          }
          if (!k) for (; c < o;) {
            (s = i()) < 9e15 && (h[c++] = s % 1e14);
          }

          for (o = h[--c], t %= l, o && t && (s = d[l - t], h[c] = a(o / s) * s); 0 === h[c]; h.pop(), c--) {
            ;
          }

          if (c < 0) h = [n = 0];else {
            for (n = -1; 0 === h[0]; h.splice(0, 1), n -= l) {
              ;
            }

            for (c = 1, s = h[0]; s >= 10; s /= 10, c++) {
              ;
            }

            c < l && (n -= l - c);
          }
          return p.e = n, p.c = h, p;
        }), V.sum = function () {
          for (var t = 1, e = arguments, r = new V(e[0]); t < e.length;) {
            r = r.plus(e[t++]);
          }

          return r;
        }, n = function () {
          function t(t, e, r, n) {
            for (var o, i, s = [0], u = 0, a = t.length; u < a;) {
              for (i = s.length; i--; s[i] *= e) {
                ;
              }

              for (s[0] += n.indexOf(t.charAt(u++)), o = 0; o < s.length; o++) {
                s[o] > r - 1 && (null == s[o + 1] && (s[o + 1] = 0), s[o + 1] += s[o] / r | 0, s[o] %= r);
              }
            }

            return s.reverse();
          }

          return function (e, n, o, i, s) {
            var u,
                a,
                f,
                c,
                h,
                l,
                p,
                d,
                g = e.indexOf("."),
                m = U,
                y = N;

            for (g >= 0 && (c = D, D = 0, e = e.replace(".", ""), l = (d = new V(n)).pow(e.length - g), D = c, d.c = t(O(b(l.c), l.e, "0"), 10, o, "0123456789"), d.e = d.c.length), f = c = (p = t(e, n, o, s ? (u = q, "0123456789") : (u = "0123456789", q))).length; 0 == p[--c]; p.pop()) {
              ;
            }

            if (!p[0]) return u.charAt(0);
            if (g < 0 ? --f : (l.c = p, l.e = f, l.s = i, p = (l = r(l, d, m, y, o)).c, h = l.r, f = l.e), g = p[a = f + m + 1], c = o / 2, h = h || a < 0 || null != p[a + 1], h = y < 4 ? (null != g || h) && (0 == y || y == (l.s < 0 ? 3 : 2)) : g > c || g == c && (4 == y || h || 6 == y && 1 & p[a - 1] || y == (l.s < 0 ? 8 : 7)), a < 1 || !p[0]) e = h ? O(u.charAt(1), -m, u.charAt(0)) : u.charAt(0);else {
              if (p.length = a, h) for (--o; ++p[--a] > o;) {
                p[a] = 0, a || (++f, p = [1].concat(p));
              }

              for (c = p.length; !p[--c];) {
                ;
              }

              for (g = 0, e = ""; g <= c; e += u.charAt(p[g++])) {
                ;
              }

              e = O(e, f, u.charAt(0));
            }
            return e;
          };
        }(), r = function () {
          function t(t, e, r) {
            var n,
                o,
                i,
                s,
                u = 0,
                a = t.length,
                f = e % g,
                c = e / g | 0;

            for (t = t.slice(); a--;) {
              u = ((o = f * (i = t[a] % g) + (n = c * i + (s = t[a] / g | 0) * f) % g * g + u) / r | 0) + (n / g | 0) + c * s, t[a] = o % r;
            }

            return u && (t = [u].concat(t)), t;
          }

          function e(t, e, r, n) {
            var o, i;
            if (r != n) i = r > n ? 1 : -1;else for (o = i = 0; o < r; o++) {
              if (t[o] != e[o]) {
                i = t[o] > e[o] ? 1 : -1;
                break;
              }
            }
            return i;
          }

          function r(t, e, r, n) {
            for (var o = 0; r--;) {
              t[r] -= o, o = t[r] < e[r] ? 1 : 0, t[r] = o * n + t[r] - e[r];
            }

            for (; !t[0] && t.length > 1; t.splice(0, 1)) {
              ;
            }
          }

          return function (n, o, i, s, u) {
            var f,
                c,
                p,
                d,
                g,
                m,
                b,
                w,
                v,
                A,
                E,
                O,
                R,
                P,
                _,
                B,
                S,
                T = n.s == o.s ? 1 : -1,
                I = n.c,
                U = o.c;

            if (!(I && I[0] && U && U[0])) return new V(n.s && o.s && (I ? !U || I[0] != U[0] : U) ? I && 0 == I[0] || !U ? 0 * T : T / 0 : NaN);

            for (v = (w = new V(T)).c = [], T = i + (c = n.e - o.e) + 1, u || (u = h, c = y(n.e / l) - y(o.e / l), T = T / l | 0), p = 0; U[p] == (I[p] || 0); p++) {
              ;
            }

            if (U[p] > (I[p] || 0) && c--, T < 0) v.push(1), d = !0;else {
              for (P = I.length, B = U.length, p = 0, T += 2, (g = a(u / (U[0] + 1))) > 1 && (U = t(U, g, u), I = t(I, g, u), B = U.length, P = I.length), R = B, E = (A = I.slice(0, B)).length; E < B; A[E++] = 0) {
                ;
              }

              S = U.slice(), S = [0].concat(S), _ = U[0], U[1] >= u / 2 && _++;

              do {
                if (g = 0, (f = e(U, A, B, E)) < 0) {
                  if (O = A[0], B != E && (O = O * u + (A[1] || 0)), (g = a(O / _)) > 1) for (g >= u && (g = u - 1), b = (m = t(U, g, u)).length, E = A.length; 1 == e(m, A, b, E);) {
                    g--, r(m, B < b ? S : U, b, u), b = m.length, f = 1;
                  } else 0 == g && (f = g = 1), b = (m = U.slice()).length;
                  if (b < E && (m = [0].concat(m)), r(A, m, E, u), E = A.length, -1 == f) for (; e(U, A, B, E) < 1;) {
                    g++, r(A, B < E ? S : U, E, u), E = A.length;
                  }
                } else 0 === f && (g++, A = [0]);

                v[p++] = g, A[0] ? A[E++] = I[R] || 0 : (A = [I[R]], E = 1);
              } while ((R++ < P || null != A[0]) && T--);

              d = null != A[0], v[0] || v.splice(0, 1);
            }

            if (u == h) {
              for (p = 1, T = v[0]; T >= 10; T /= 10, p++) {
                ;
              }

              z(w, i + (w.e = p + c * l - 1) + 1, s, d);
            } else w.e = c, w.r = +d;

            return w;
          };
        }(), R = /^(-?)0([xbo])(?=\w[\w.]*$)/i, P = /^([^.]+)\.$/, _ = /^\.([^.]+)$/, B = /^-?(Infinity|NaN)$/, S = /^\s*\+(?=[\w.])|^\s+|\s+$/g, o = function o(t, e, r, n) {
          var o,
              i = r ? e : e.replace(S, "");
          if (B.test(i)) t.s = isNaN(i) ? null : i < 0 ? -1 : 1;else {
            if (!r && (i = i.replace(R, function (t, e, r) {
              return o = "x" == (r = r.toLowerCase()) ? 16 : "b" == r ? 2 : 8, n && n != o ? t : e;
            }), n && (o = n, i = i.replace(P, "$1").replace(_, "0.$1")), e != i)) return new V(i, o);
            if (V.DEBUG) throw Error(f + "Not a" + (n ? " base " + n : "") + " number: " + e);
            t.s = null;
          }
          t.c = t.e = null;
        }, T.absoluteValue = T.abs = function () {
          var t = new V(this);
          return t.s < 0 && (t.s = 1), t;
        }, T.comparedTo = function (t, e) {
          return w(this, new V(t, e));
        }, T.decimalPlaces = T.dp = function (t, e) {
          var r,
              n,
              o,
              i = this;
          if (null != t) return v(t, 0, m), null == e ? e = N : v(e, 0, 8), z(new V(i), t + i.e + 1, e);
          if (!(r = i.c)) return null;
          if (n = ((o = r.length - 1) - y(this.e / l)) * l, o = r[o]) for (; o % 10 == 0; o /= 10, n--) {
            ;
          }
          return n < 0 && (n = 0), n;
        }, T.dividedBy = T.div = function (t, e) {
          return r(this, new V(t, e), U, N);
        }, T.dividedToIntegerBy = T.idiv = function (t, e) {
          return r(this, new V(t, e), 0, 1);
        }, T.exponentiatedBy = T.pow = function (t, e) {
          var r,
              n,
              o,
              i,
              s,
              c,
              h,
              p,
              d = this;
          if ((t = new V(t)).c && !t.isInteger()) throw Error(f + "Exponent not an integer: " + W(t));
          if (null != e && (e = new V(e)), s = t.e > 14, !d.c || !d.c[0] || 1 == d.c[0] && !d.e && 1 == d.c.length || !t.c || !t.c[0]) return p = new V(Math.pow(+W(d), s ? 2 - A(t) : +W(t))), e ? p.mod(e) : p;

          if (c = t.s < 0, e) {
            if (e.c ? !e.c[0] : !e.s) return new V(NaN);
            (n = !c && d.isInteger() && e.isInteger()) && (d = d.mod(e));
          } else {
            if (t.e > 9 && (d.e > 0 || d.e < -1 || (0 == d.e ? d.c[0] > 1 || s && d.c[1] >= 24e7 : d.c[0] < 8e13 || s && d.c[0] <= 9999975e7))) return i = d.s < 0 && A(t) ? -0 : 0, d.e > -1 && (i = 1 / i), new V(c ? 1 / i : i);
            D && (i = u(D / l + 2));
          }

          for (s ? (r = new V(.5), c && (t.s = 1), h = A(t)) : h = (o = Math.abs(+W(t))) % 2, p = new V(I);;) {
            if (h) {
              if (!(p = p.times(d)).c) break;
              i ? p.c.length > i && (p.c.length = i) : n && (p = p.mod(e));
            }

            if (o) {
              if (0 === (o = a(o / 2))) break;
              h = o % 2;
            } else if (z(t = t.times(r), t.e + 1, 1), t.e > 14) h = A(t);else {
              if (0 === (o = +W(t))) break;
              h = o % 2;
            }

            d = d.times(d), i ? d.c && d.c.length > i && (d.c.length = i) : n && (d = d.mod(e));
          }

          return n ? p : (c && (p = I.div(p)), e ? p.mod(e) : i ? z(p, D, N, void 0) : p);
        }, T.integerValue = function (t) {
          var e = new V(this);
          return null == t ? t = N : v(t, 0, 8), z(e, e.e + 1, t);
        }, T.isEqualTo = T.eq = function (t, e) {
          return 0 === w(this, new V(t, e));
        }, T.isFinite = function () {
          return !!this.c;
        }, T.isGreaterThan = T.gt = function (t, e) {
          return w(this, new V(t, e)) > 0;
        }, T.isGreaterThanOrEqualTo = T.gte = function (t, e) {
          return 1 === (e = w(this, new V(t, e))) || 0 === e;
        }, T.isInteger = function () {
          return !!this.c && y(this.e / l) > this.c.length - 2;
        }, T.isLessThan = T.lt = function (t, e) {
          return w(this, new V(t, e)) < 0;
        }, T.isLessThanOrEqualTo = T.lte = function (t, e) {
          return -1 === (e = w(this, new V(t, e))) || 0 === e;
        }, T.isNaN = function () {
          return !this.s;
        }, T.isNegative = function () {
          return this.s < 0;
        }, T.isPositive = function () {
          return this.s > 0;
        }, T.isZero = function () {
          return !!this.c && 0 == this.c[0];
        }, T.minus = function (t, e) {
          var r,
              n,
              o,
              i,
              s = this,
              u = s.s;
          if (e = (t = new V(t, e)).s, !u || !e) return new V(NaN);
          if (u != e) return t.s = -e, s.plus(t);
          var a = s.e / l,
              f = t.e / l,
              c = s.c,
              p = t.c;

          if (!a || !f) {
            if (!c || !p) return c ? (t.s = -e, t) : new V(p ? s : NaN);
            if (!c[0] || !p[0]) return p[0] ? (t.s = -e, t) : new V(c[0] ? s : 3 == N ? -0 : 0);
          }

          if (a = y(a), f = y(f), c = c.slice(), u = a - f) {
            for ((i = u < 0) ? (u = -u, o = c) : (f = a, o = p), o.reverse(), e = u; e--; o.push(0)) {
              ;
            }

            o.reverse();
          } else for (n = (i = (u = c.length) < (e = p.length)) ? u : e, u = e = 0; e < n; e++) {
            if (c[e] != p[e]) {
              i = c[e] < p[e];
              break;
            }
          }

          if (i && (o = c, c = p, p = o, t.s = -t.s), (e = (n = p.length) - (r = c.length)) > 0) for (; e--; c[r++] = 0) {
            ;
          }

          for (e = h - 1; n > u;) {
            if (c[--n] < p[n]) {
              for (r = n; r && !c[--r]; c[r] = e) {
                ;
              }

              --c[r], c[n] += h;
            }

            c[n] -= p[n];
          }

          for (; 0 == c[0]; c.splice(0, 1), --f) {
            ;
          }

          return c[0] ? G(t, c, f) : (t.s = 3 == N ? -1 : 1, t.c = [t.e = 0], t);
        }, T.modulo = T.mod = function (t, e) {
          var n,
              o,
              i = this;
          return t = new V(t, e), !i.c || !t.s || t.c && !t.c[0] ? new V(NaN) : !t.c || i.c && !i.c[0] ? new V(i) : (9 == M ? (o = t.s, t.s = 1, n = r(i, t, 0, 3), t.s = o, n.s *= o) : n = r(i, t, 0, M), (t = i.minus(n.times(t))).c[0] || 1 != M || (t.s = i.s), t);
        }, T.multipliedBy = T.times = function (t, e) {
          var r,
              n,
              o,
              i,
              s,
              u,
              a,
              f,
              c,
              p,
              d,
              m,
              b,
              w,
              v,
              A = this,
              E = A.c,
              O = (t = new V(t, e)).c;
          if (!(E && O && E[0] && O[0])) return !A.s || !t.s || E && !E[0] && !O || O && !O[0] && !E ? t.c = t.e = t.s = null : (t.s *= A.s, E && O ? (t.c = [0], t.e = 0) : t.c = t.e = null), t;

          for (n = y(A.e / l) + y(t.e / l), t.s *= A.s, (a = E.length) < (p = O.length) && (b = E, E = O, O = b, o = a, a = p, p = o), o = a + p, b = []; o--; b.push(0)) {
            ;
          }

          for (w = h, v = g, o = p; --o >= 0;) {
            for (r = 0, d = O[o] % v, m = O[o] / v | 0, i = o + (s = a); i > o;) {
              r = ((f = d * (f = E[--s] % v) + (u = m * f + (c = E[s] / v | 0) * d) % v * v + b[i] + r) / w | 0) + (u / v | 0) + m * c, b[i--] = f % w;
            }

            b[i] = r;
          }

          return r ? ++n : b.splice(0, 1), G(t, b, n);
        }, T.negated = function () {
          var t = new V(this);
          return t.s = -t.s || null, t;
        }, T.plus = function (t, e) {
          var r,
              n = this,
              o = n.s;
          if (e = (t = new V(t, e)).s, !o || !e) return new V(NaN);
          if (o != e) return t.s = -e, n.minus(t);
          var i = n.e / l,
              s = t.e / l,
              u = n.c,
              a = t.c;

          if (!i || !s) {
            if (!u || !a) return new V(o / 0);
            if (!u[0] || !a[0]) return a[0] ? t : new V(u[0] ? n : 0 * o);
          }

          if (i = y(i), s = y(s), u = u.slice(), o = i - s) {
            for (o > 0 ? (s = i, r = a) : (o = -o, r = u), r.reverse(); o--; r.push(0)) {
              ;
            }

            r.reverse();
          }

          for ((o = u.length) - (e = a.length) < 0 && (r = a, a = u, u = r, e = o), o = 0; e;) {
            o = (u[--e] = u[e] + a[e] + o) / h | 0, u[e] = h === u[e] ? 0 : u[e] % h;
          }

          return o && (u = [o].concat(u), ++s), G(t, u, s);
        }, T.precision = T.sd = function (t, e) {
          var r,
              n,
              o,
              i = this;
          if (null != t && t !== !!t) return v(t, 1, m), null == e ? e = N : v(e, 0, 8), z(new V(i), t, e);
          if (!(r = i.c)) return null;

          if (n = (o = r.length - 1) * l + 1, o = r[o]) {
            for (; o % 10 == 0; o /= 10, n--) {
              ;
            }

            for (o = r[0]; o >= 10; o /= 10, n++) {
              ;
            }
          }

          return t && i.e + 1 > n && (n = i.e + 1), n;
        }, T.shiftedBy = function (t) {
          return v(t, -p, p), this.times("1e" + t);
        }, T.squareRoot = T.sqrt = function () {
          var t,
              e,
              n,
              o,
              i,
              s = this,
              u = s.c,
              a = s.s,
              f = s.e,
              c = U + 4,
              h = new V("0.5");
          if (1 !== a || !u || !u[0]) return new V(!a || a < 0 && (!u || u[0]) ? NaN : u ? s : 1 / 0);
          if (0 == (a = Math.sqrt(+W(s))) || a == 1 / 0 ? (((e = b(u)).length + f) % 2 == 0 && (e += "0"), a = Math.sqrt(+e), f = y((f + 1) / 2) - (f < 0 || f % 2), n = new V(e = a == 1 / 0 ? "1e" + f : (e = a.toExponential()).slice(0, e.indexOf("e") + 1) + f)) : n = new V(a + ""), n.c[0]) for ((a = (f = n.e) + c) < 3 && (a = 0);;) {
            if (i = n, n = h.times(i.plus(r(s, i, c, 1))), b(i.c).slice(0, a) === (e = b(n.c)).slice(0, a)) {
              if (n.e < f && --a, "9999" != (e = e.slice(a - 3, a + 1)) && (o || "4999" != e)) {
                +e && (+e.slice(1) || "5" != e.charAt(0)) || (z(n, n.e + U + 2, 1), t = !n.times(n).eq(s));
                break;
              }

              if (!o && (z(i, i.e + U + 2, 0), i.times(i).eq(s))) {
                n = i;
                break;
              }

              c += 4, a += 4, o = 1;
            }
          }
          return z(n, n.e + U + 1, N, t);
        }, T.toExponential = function (t, e) {
          return null != t && (v(t, 0, m), t++), F(this, t, e, 1);
        }, T.toFixed = function (t, e) {
          return null != t && (v(t, 0, m), t = t + this.e + 1), F(this, t, e);
        }, T.toFormat = function (t, e, r) {
          var n,
              o = this;
          if (null == r) null != t && e && "object" == typeof e ? (r = e, e = null) : t && "object" == typeof t ? (r = t, t = e = null) : r = Y;else if ("object" != typeof r) throw Error(f + "Argument not an object: " + r);

          if (n = o.toFixed(t, e), o.c) {
            var i,
                s = n.split("."),
                u = +r.groupSize,
                a = +r.secondaryGroupSize,
                c = r.groupSeparator || "",
                h = s[0],
                l = s[1],
                p = o.s < 0,
                d = p ? h.slice(1) : h,
                g = d.length;

            if (a && (i = u, u = a, a = i, g -= i), u > 0 && g > 0) {
              for (i = g % u || u, h = d.substr(0, i); i < g; i += u) {
                h += c + d.substr(i, u);
              }

              a > 0 && (h += c + d.slice(i)), p && (h = "-" + h);
            }

            n = l ? h + (r.decimalSeparator || "") + ((a = +r.fractionGroupSize) ? l.replace(new RegExp("\\d{" + a + "}\\B", "g"), "$&" + (r.fractionGroupSeparator || "")) : l) : h;
          }

          return (r.prefix || "") + n + (r.suffix || "");
        }, T.toFraction = function (t) {
          var e,
              n,
              o,
              i,
              s,
              u,
              a,
              c,
              h,
              p,
              g,
              m,
              y = this,
              w = y.c;
          if (null != t && (!(a = new V(t)).isInteger() && (a.c || 1 !== a.s) || a.lt(I))) throw Error(f + "Argument " + (a.isInteger() ? "out of range: " : "not an integer: ") + W(a));
          if (!w) return new V(y);

          for (e = new V(I), h = n = new V(I), o = c = new V(I), m = b(w), s = e.e = m.length - y.e - 1, e.c[0] = d[(u = s % l) < 0 ? l + u : u], t = !t || a.comparedTo(e) > 0 ? s > 0 ? e : h : a, u = j, j = 1 / 0, a = new V(m), c.c[0] = 0; p = r(a, e, 0, 1), 1 != (i = n.plus(p.times(o))).comparedTo(t);) {
            n = o, o = i, h = c.plus(p.times(i = h)), c = i, e = a.minus(p.times(i = e)), a = i;
          }

          return i = r(t.minus(n), o, 0, 1), c = c.plus(i.times(h)), n = n.plus(i.times(o)), c.s = h.s = y.s, g = r(h, o, s *= 2, N).minus(y).abs().comparedTo(r(c, n, s, N).minus(y).abs()) < 1 ? [h, o] : [c, n], j = u, g;
        }, T.toNumber = function () {
          return +W(this);
        }, T.toPrecision = function (t, e) {
          return null != t && v(t, 1, m), F(this, t, e, 2);
        }, T.toString = function (t) {
          var e,
              r = this,
              o = r.s,
              i = r.e;
          return null === i ? o ? (e = "Infinity", o < 0 && (e = "-" + e)) : e = "NaN" : (null == t ? e = i <= L || i >= x ? E(b(r.c), i) : O(b(r.c), i, "0") : 10 === t ? e = O(b((r = z(new V(r), U + i + 1, N)).c), r.e, "0") : (v(t, 2, q.length, "Base"), e = n(O(b(r.c), i, "0"), 10, t, o, !0)), o < 0 && r.c[0] && (e = "-" + e)), e;
        }, T.valueOf = T.toJSON = function () {
          return W(this);
        }, T._isBigNumber = !0, null != e && V.set(e), V;
      }())["default"] = i.BigNumber = i, void 0 === (n = function () {
        return i;
      }.call(e, r, e, t)) || (t.exports = n);
    }();
  }, function (t, e) {
    var r;

    r = function () {
      return this;
    }();

    try {
      r = r || new Function("return this")();
    } catch (t) {
      "object" == typeof window && (r = window);
    }

    t.exports = r;
  }, function (t, e, r) {
    "use strict";

    (function (t) {
      /*!
       * The buffer module from node.js, for the browser.
       *
       * @author   Feross Aboukhadijeh <http://feross.org>
       * @license  MIT
       */
      var n = r(9),
          o = r(10),
          i = r(11);

      function s() {
        return a.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
      }

      function u(t, e) {
        if (s() < e) throw new RangeError("Invalid typed array length");
        return a.TYPED_ARRAY_SUPPORT ? (t = new Uint8Array(e)).__proto__ = a.prototype : (null === t && (t = new a(e)), t.length = e), t;
      }

      function a(t, e, r) {
        if (!(a.TYPED_ARRAY_SUPPORT || this instanceof a)) return new a(t, e, r);

        if ("number" == typeof t) {
          if ("string" == typeof e) throw new Error("If encoding is specified then the first argument must be a string");
          return h(this, t);
        }

        return f(this, t, e, r);
      }

      function f(t, e, r, n) {
        if ("number" == typeof e) throw new TypeError('"value" argument must not be a number');
        return "undefined" != typeof ArrayBuffer && e instanceof ArrayBuffer ? function (t, e, r, n) {
          if (e.byteLength, r < 0 || e.byteLength < r) throw new RangeError("'offset' is out of bounds");
          if (e.byteLength < r + (n || 0)) throw new RangeError("'length' is out of bounds");
          e = void 0 === r && void 0 === n ? new Uint8Array(e) : void 0 === n ? new Uint8Array(e, r) : new Uint8Array(e, r, n);
          a.TYPED_ARRAY_SUPPORT ? (t = e).__proto__ = a.prototype : t = l(t, e);
          return t;
        }(t, e, r, n) : "string" == typeof e ? function (t, e, r) {
          "string" == typeof r && "" !== r || (r = "utf8");
          if (!a.isEncoding(r)) throw new TypeError('"encoding" must be a valid string encoding');
          var n = 0 | d(e, r),
              o = (t = u(t, n)).write(e, r);
          o !== n && (t = t.slice(0, o));
          return t;
        }(t, e, r) : function (t, e) {
          if (a.isBuffer(e)) {
            var r = 0 | p(e.length);
            return 0 === (t = u(t, r)).length ? t : (e.copy(t, 0, 0, r), t);
          }

          if (e) {
            if ("undefined" != typeof ArrayBuffer && e.buffer instanceof ArrayBuffer || "length" in e) return "number" != typeof e.length || (n = e.length) != n ? u(t, 0) : l(t, e);
            if ("Buffer" === e.type && i(e.data)) return l(t, e.data);
          }

          var n;
          throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
        }(t, e);
      }

      function c(t) {
        if ("number" != typeof t) throw new TypeError('"size" argument must be a number');
        if (t < 0) throw new RangeError('"size" argument must not be negative');
      }

      function h(t, e) {
        if (c(e), t = u(t, e < 0 ? 0 : 0 | p(e)), !a.TYPED_ARRAY_SUPPORT) for (var r = 0; r < e; ++r) {
          t[r] = 0;
        }
        return t;
      }

      function l(t, e) {
        var r = e.length < 0 ? 0 : 0 | p(e.length);
        t = u(t, r);

        for (var n = 0; n < r; n += 1) {
          t[n] = 255 & e[n];
        }

        return t;
      }

      function p(t) {
        if (t >= s()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + s().toString(16) + " bytes");
        return 0 | t;
      }

      function d(t, e) {
        if (a.isBuffer(t)) return t.length;
        if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(t) || t instanceof ArrayBuffer)) return t.byteLength;
        "string" != typeof t && (t = "" + t);
        var r = t.length;
        if (0 === r) return 0;

        for (var n = !1;;) {
          switch (e) {
            case "ascii":
            case "latin1":
            case "binary":
              return r;

            case "utf8":
            case "utf-8":
            case void 0:
              return q(t).length;

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return 2 * r;

            case "hex":
              return r >>> 1;

            case "base64":
              return V(t).length;

            default:
              if (n) return q(t).length;
              e = ("" + e).toLowerCase(), n = !0;
          }
        }
      }

      function g(t, e, r) {
        var n = !1;
        if ((void 0 === e || e < 0) && (e = 0), e > this.length) return "";
        if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
        if ((r >>>= 0) <= (e >>>= 0)) return "";

        for (t || (t = "utf8");;) {
          switch (t) {
            case "hex":
              return I(this, e, r);

            case "utf8":
            case "utf-8":
              return _(this, e, r);

            case "ascii":
              return S(this, e, r);

            case "latin1":
            case "binary":
              return T(this, e, r);

            case "base64":
              return P(this, e, r);

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return U(this, e, r);

            default:
              if (n) throw new TypeError("Unknown encoding: " + t);
              t = (t + "").toLowerCase(), n = !0;
          }
        }
      }

      function m(t, e, r) {
        var n = t[e];
        t[e] = t[r], t[r] = n;
      }

      function y(t, e, r, n, o) {
        if (0 === t.length) return -1;

        if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), r = +r, isNaN(r) && (r = o ? 0 : t.length - 1), r < 0 && (r = t.length + r), r >= t.length) {
          if (o) return -1;
          r = t.length - 1;
        } else if (r < 0) {
          if (!o) return -1;
          r = 0;
        }

        if ("string" == typeof e && (e = a.from(e, n)), a.isBuffer(e)) return 0 === e.length ? -1 : b(t, e, r, n, o);
        if ("number" == typeof e) return e &= 255, a.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? o ? Uint8Array.prototype.indexOf.call(t, e, r) : Uint8Array.prototype.lastIndexOf.call(t, e, r) : b(t, [e], r, n, o);
        throw new TypeError("val must be string, number or Buffer");
      }

      function b(t, e, r, n, o) {
        var i,
            s = 1,
            u = t.length,
            a = e.length;

        if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
          if (t.length < 2 || e.length < 2) return -1;
          s = 2, u /= 2, a /= 2, r /= 2;
        }

        function f(t, e) {
          return 1 === s ? t[e] : t.readUInt16BE(e * s);
        }

        if (o) {
          var c = -1;

          for (i = r; i < u; i++) {
            if (f(t, i) === f(e, -1 === c ? 0 : i - c)) {
              if (-1 === c && (c = i), i - c + 1 === a) return c * s;
            } else -1 !== c && (i -= i - c), c = -1;
          }
        } else for (r + a > u && (r = u - a), i = r; i >= 0; i--) {
          for (var h = !0, l = 0; l < a; l++) {
            if (f(t, i + l) !== f(e, l)) {
              h = !1;
              break;
            }
          }

          if (h) return i;
        }

        return -1;
      }

      function w(t, e, r, n) {
        r = Number(r) || 0;
        var o = t.length - r;
        n ? (n = Number(n)) > o && (n = o) : n = o;
        var i = e.length;
        if (i % 2 != 0) throw new TypeError("Invalid hex string");
        n > i / 2 && (n = i / 2);

        for (var s = 0; s < n; ++s) {
          var u = parseInt(e.substr(2 * s, 2), 16);
          if (isNaN(u)) return s;
          t[r + s] = u;
        }

        return s;
      }

      function v(t, e, r, n) {
        return F(q(e, t.length - r), t, r, n);
      }

      function A(t, e, r, n) {
        return F(function (t) {
          for (var e = [], r = 0; r < t.length; ++r) {
            e.push(255 & t.charCodeAt(r));
          }

          return e;
        }(e), t, r, n);
      }

      function E(t, e, r, n) {
        return A(t, e, r, n);
      }

      function O(t, e, r, n) {
        return F(V(e), t, r, n);
      }

      function R(t, e, r, n) {
        return F(function (t, e) {
          for (var r, n, o, i = [], s = 0; s < t.length && !((e -= 2) < 0); ++s) {
            r = t.charCodeAt(s), n = r >> 8, o = r % 256, i.push(o), i.push(n);
          }

          return i;
        }(e, t.length - r), t, r, n);
      }

      function P(t, e, r) {
        return 0 === e && r === t.length ? n.fromByteArray(t) : n.fromByteArray(t.slice(e, r));
      }

      function _(t, e, r) {
        r = Math.min(t.length, r);

        for (var n = [], o = e; o < r;) {
          var i,
              s,
              u,
              a,
              f = t[o],
              c = null,
              h = f > 239 ? 4 : f > 223 ? 3 : f > 191 ? 2 : 1;
          if (o + h <= r) switch (h) {
            case 1:
              f < 128 && (c = f);
              break;

            case 2:
              128 == (192 & (i = t[o + 1])) && (a = (31 & f) << 6 | 63 & i) > 127 && (c = a);
              break;

            case 3:
              i = t[o + 1], s = t[o + 2], 128 == (192 & i) && 128 == (192 & s) && (a = (15 & f) << 12 | (63 & i) << 6 | 63 & s) > 2047 && (a < 55296 || a > 57343) && (c = a);
              break;

            case 4:
              i = t[o + 1], s = t[o + 2], u = t[o + 3], 128 == (192 & i) && 128 == (192 & s) && 128 == (192 & u) && (a = (15 & f) << 18 | (63 & i) << 12 | (63 & s) << 6 | 63 & u) > 65535 && a < 1114112 && (c = a);
          }
          null === c ? (c = 65533, h = 1) : c > 65535 && (c -= 65536, n.push(c >>> 10 & 1023 | 55296), c = 56320 | 1023 & c), n.push(c), o += h;
        }

        return function (t) {
          var e = t.length;
          if (e <= B) return String.fromCharCode.apply(String, t);
          var r = "",
              n = 0;

          for (; n < e;) {
            r += String.fromCharCode.apply(String, t.slice(n, n += B));
          }

          return r;
        }(n);
      }

      e.Buffer = a, e.SlowBuffer = function (t) {
        +t != t && (t = 0);
        return a.alloc(+t);
      }, e.INSPECT_MAX_BYTES = 50, a.TYPED_ARRAY_SUPPORT = void 0 !== t.TYPED_ARRAY_SUPPORT ? t.TYPED_ARRAY_SUPPORT : function () {
        try {
          var t = new Uint8Array(1);
          return t.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function foo() {
              return 42;
            }
          }, 42 === t.foo() && "function" == typeof t.subarray && 0 === t.subarray(1, 1).byteLength;
        } catch (t) {
          return !1;
        }
      }(), e.kMaxLength = s(), a.poolSize = 8192, a._augment = function (t) {
        return t.__proto__ = a.prototype, t;
      }, a.from = function (t, e, r) {
        return f(null, t, e, r);
      }, a.TYPED_ARRAY_SUPPORT && (a.prototype.__proto__ = Uint8Array.prototype, a.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && a[Symbol.species] === a && Object.defineProperty(a, Symbol.species, {
        value: null,
        configurable: !0
      })), a.alloc = function (t, e, r) {
        return function (t, e, r, n) {
          return c(e), e <= 0 ? u(t, e) : void 0 !== r ? "string" == typeof n ? u(t, e).fill(r, n) : u(t, e).fill(r) : u(t, e);
        }(null, t, e, r);
      }, a.allocUnsafe = function (t) {
        return h(null, t);
      }, a.allocUnsafeSlow = function (t) {
        return h(null, t);
      }, a.isBuffer = function (t) {
        return !(null == t || !t._isBuffer);
      }, a.compare = function (t, e) {
        if (!a.isBuffer(t) || !a.isBuffer(e)) throw new TypeError("Arguments must be Buffers");
        if (t === e) return 0;

        for (var r = t.length, n = e.length, o = 0, i = Math.min(r, n); o < i; ++o) {
          if (t[o] !== e[o]) {
            r = t[o], n = e[o];
            break;
          }
        }

        return r < n ? -1 : n < r ? 1 : 0;
      }, a.isEncoding = function (t) {
        switch (String(t).toLowerCase()) {
          case "hex":
          case "utf8":
          case "utf-8":
          case "ascii":
          case "latin1":
          case "binary":
          case "base64":
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return !0;

          default:
            return !1;
        }
      }, a.concat = function (t, e) {
        if (!i(t)) throw new TypeError('"list" argument must be an Array of Buffers');
        if (0 === t.length) return a.alloc(0);
        var r;
        if (void 0 === e) for (e = 0, r = 0; r < t.length; ++r) {
          e += t[r].length;
        }
        var n = a.allocUnsafe(e),
            o = 0;

        for (r = 0; r < t.length; ++r) {
          var s = t[r];
          if (!a.isBuffer(s)) throw new TypeError('"list" argument must be an Array of Buffers');
          s.copy(n, o), o += s.length;
        }

        return n;
      }, a.byteLength = d, a.prototype._isBuffer = !0, a.prototype.swap16 = function () {
        var t = this.length;
        if (t % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");

        for (var e = 0; e < t; e += 2) {
          m(this, e, e + 1);
        }

        return this;
      }, a.prototype.swap32 = function () {
        var t = this.length;
        if (t % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");

        for (var e = 0; e < t; e += 4) {
          m(this, e, e + 3), m(this, e + 1, e + 2);
        }

        return this;
      }, a.prototype.swap64 = function () {
        var t = this.length;
        if (t % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");

        for (var e = 0; e < t; e += 8) {
          m(this, e, e + 7), m(this, e + 1, e + 6), m(this, e + 2, e + 5), m(this, e + 3, e + 4);
        }

        return this;
      }, a.prototype.toString = function () {
        var t = 0 | this.length;
        return 0 === t ? "" : 0 === arguments.length ? _(this, 0, t) : g.apply(this, arguments);
      }, a.prototype.equals = function (t) {
        if (!a.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
        return this === t || 0 === a.compare(this, t);
      }, a.prototype.inspect = function () {
        var t = "",
            r = e.INSPECT_MAX_BYTES;
        return this.length > 0 && (t = this.toString("hex", 0, r).match(/.{2}/g).join(" "), this.length > r && (t += " ... ")), "<Buffer " + t + ">";
      }, a.prototype.compare = function (t, e, r, n, o) {
        if (!a.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
        if (void 0 === e && (e = 0), void 0 === r && (r = t ? t.length : 0), void 0 === n && (n = 0), void 0 === o && (o = this.length), e < 0 || r > t.length || n < 0 || o > this.length) throw new RangeError("out of range index");
        if (n >= o && e >= r) return 0;
        if (n >= o) return -1;
        if (e >= r) return 1;
        if (this === t) return 0;

        for (var i = (o >>>= 0) - (n >>>= 0), s = (r >>>= 0) - (e >>>= 0), u = Math.min(i, s), f = this.slice(n, o), c = t.slice(e, r), h = 0; h < u; ++h) {
          if (f[h] !== c[h]) {
            i = f[h], s = c[h];
            break;
          }
        }

        return i < s ? -1 : s < i ? 1 : 0;
      }, a.prototype.includes = function (t, e, r) {
        return -1 !== this.indexOf(t, e, r);
      }, a.prototype.indexOf = function (t, e, r) {
        return y(this, t, e, r, !0);
      }, a.prototype.lastIndexOf = function (t, e, r) {
        return y(this, t, e, r, !1);
      }, a.prototype.write = function (t, e, r, n) {
        if (void 0 === e) n = "utf8", r = this.length, e = 0;else if (void 0 === r && "string" == typeof e) n = e, r = this.length, e = 0;else {
          if (!isFinite(e)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
          e |= 0, isFinite(r) ? (r |= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
        }
        var o = this.length - e;
        if ((void 0 === r || r > o) && (r = o), t.length > 0 && (r < 0 || e < 0) || e > this.length) throw new RangeError("Attempt to write outside buffer bounds");
        n || (n = "utf8");

        for (var i = !1;;) {
          switch (n) {
            case "hex":
              return w(this, t, e, r);

            case "utf8":
            case "utf-8":
              return v(this, t, e, r);

            case "ascii":
              return A(this, t, e, r);

            case "latin1":
            case "binary":
              return E(this, t, e, r);

            case "base64":
              return O(this, t, e, r);

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return R(this, t, e, r);

            default:
              if (i) throw new TypeError("Unknown encoding: " + n);
              n = ("" + n).toLowerCase(), i = !0;
          }
        }
      }, a.prototype.toJSON = function () {
        return {
          type: "Buffer",
          data: Array.prototype.slice.call(this._arr || this, 0)
        };
      };
      var B = 4096;

      function S(t, e, r) {
        var n = "";
        r = Math.min(t.length, r);

        for (var o = e; o < r; ++o) {
          n += String.fromCharCode(127 & t[o]);
        }

        return n;
      }

      function T(t, e, r) {
        var n = "";
        r = Math.min(t.length, r);

        for (var o = e; o < r; ++o) {
          n += String.fromCharCode(t[o]);
        }

        return n;
      }

      function I(t, e, r) {
        var n = t.length;
        (!e || e < 0) && (e = 0), (!r || r < 0 || r > n) && (r = n);

        for (var o = "", i = e; i < r; ++i) {
          o += Y(t[i]);
        }

        return o;
      }

      function U(t, e, r) {
        for (var n = t.slice(e, r), o = "", i = 0; i < n.length; i += 2) {
          o += String.fromCharCode(n[i] + 256 * n[i + 1]);
        }

        return o;
      }

      function N(t, e, r) {
        if (t % 1 != 0 || t < 0) throw new RangeError("offset is not uint");
        if (t + e > r) throw new RangeError("Trying to access beyond buffer length");
      }

      function L(t, e, r, n, o, i) {
        if (!a.isBuffer(t)) throw new TypeError('"buffer" argument must be a Buffer instance');
        if (e > o || e < i) throw new RangeError('"value" argument is out of bounds');
        if (r + n > t.length) throw new RangeError("Index out of range");
      }

      function x(t, e, r, n) {
        e < 0 && (e = 65535 + e + 1);

        for (var o = 0, i = Math.min(t.length - r, 2); o < i; ++o) {
          t[r + o] = (e & 255 << 8 * (n ? o : 1 - o)) >>> 8 * (n ? o : 1 - o);
        }
      }

      function C(t, e, r, n) {
        e < 0 && (e = 4294967295 + e + 1);

        for (var o = 0, i = Math.min(t.length - r, 4); o < i; ++o) {
          t[r + o] = e >>> 8 * (n ? o : 3 - o) & 255;
        }
      }

      function j(t, e, r, n, o, i) {
        if (r + n > t.length) throw new RangeError("Index out of range");
        if (r < 0) throw new RangeError("Index out of range");
      }

      function k(t, e, r, n, i) {
        return i || j(t, 0, r, 4), o.write(t, e, r, n, 23, 4), r + 4;
      }

      function M(t, e, r, n, i) {
        return i || j(t, 0, r, 8), o.write(t, e, r, n, 52, 8), r + 8;
      }

      a.prototype.slice = function (t, e) {
        var r,
            n = this.length;
        if ((t = ~~t) < 0 ? (t += n) < 0 && (t = 0) : t > n && (t = n), (e = void 0 === e ? n : ~~e) < 0 ? (e += n) < 0 && (e = 0) : e > n && (e = n), e < t && (e = t), a.TYPED_ARRAY_SUPPORT) (r = this.subarray(t, e)).__proto__ = a.prototype;else {
          var o = e - t;
          r = new a(o, void 0);

          for (var i = 0; i < o; ++i) {
            r[i] = this[i + t];
          }
        }
        return r;
      }, a.prototype.readUIntLE = function (t, e, r) {
        t |= 0, e |= 0, r || N(t, e, this.length);

        for (var n = this[t], o = 1, i = 0; ++i < e && (o *= 256);) {
          n += this[t + i] * o;
        }

        return n;
      }, a.prototype.readUIntBE = function (t, e, r) {
        t |= 0, e |= 0, r || N(t, e, this.length);

        for (var n = this[t + --e], o = 1; e > 0 && (o *= 256);) {
          n += this[t + --e] * o;
        }

        return n;
      }, a.prototype.readUInt8 = function (t, e) {
        return e || N(t, 1, this.length), this[t];
      }, a.prototype.readUInt16LE = function (t, e) {
        return e || N(t, 2, this.length), this[t] | this[t + 1] << 8;
      }, a.prototype.readUInt16BE = function (t, e) {
        return e || N(t, 2, this.length), this[t] << 8 | this[t + 1];
      }, a.prototype.readUInt32LE = function (t, e) {
        return e || N(t, 4, this.length), (this[t] | this[t + 1] << 8 | this[t + 2] << 16) + 16777216 * this[t + 3];
      }, a.prototype.readUInt32BE = function (t, e) {
        return e || N(t, 4, this.length), 16777216 * this[t] + (this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3]);
      }, a.prototype.readIntLE = function (t, e, r) {
        t |= 0, e |= 0, r || N(t, e, this.length);

        for (var n = this[t], o = 1, i = 0; ++i < e && (o *= 256);) {
          n += this[t + i] * o;
        }

        return n >= (o *= 128) && (n -= Math.pow(2, 8 * e)), n;
      }, a.prototype.readIntBE = function (t, e, r) {
        t |= 0, e |= 0, r || N(t, e, this.length);

        for (var n = e, o = 1, i = this[t + --n]; n > 0 && (o *= 256);) {
          i += this[t + --n] * o;
        }

        return i >= (o *= 128) && (i -= Math.pow(2, 8 * e)), i;
      }, a.prototype.readInt8 = function (t, e) {
        return e || N(t, 1, this.length), 128 & this[t] ? -1 * (255 - this[t] + 1) : this[t];
      }, a.prototype.readInt16LE = function (t, e) {
        e || N(t, 2, this.length);
        var r = this[t] | this[t + 1] << 8;
        return 32768 & r ? 4294901760 | r : r;
      }, a.prototype.readInt16BE = function (t, e) {
        e || N(t, 2, this.length);
        var r = this[t + 1] | this[t] << 8;
        return 32768 & r ? 4294901760 | r : r;
      }, a.prototype.readInt32LE = function (t, e) {
        return e || N(t, 4, this.length), this[t] | this[t + 1] << 8 | this[t + 2] << 16 | this[t + 3] << 24;
      }, a.prototype.readInt32BE = function (t, e) {
        return e || N(t, 4, this.length), this[t] << 24 | this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3];
      }, a.prototype.readFloatLE = function (t, e) {
        return e || N(t, 4, this.length), o.read(this, t, !0, 23, 4);
      }, a.prototype.readFloatBE = function (t, e) {
        return e || N(t, 4, this.length), o.read(this, t, !1, 23, 4);
      }, a.prototype.readDoubleLE = function (t, e) {
        return e || N(t, 8, this.length), o.read(this, t, !0, 52, 8);
      }, a.prototype.readDoubleBE = function (t, e) {
        return e || N(t, 8, this.length), o.read(this, t, !1, 52, 8);
      }, a.prototype.writeUIntLE = function (t, e, r, n) {
        (t = +t, e |= 0, r |= 0, n) || L(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
        var o = 1,
            i = 0;

        for (this[e] = 255 & t; ++i < r && (o *= 256);) {
          this[e + i] = t / o & 255;
        }

        return e + r;
      }, a.prototype.writeUIntBE = function (t, e, r, n) {
        (t = +t, e |= 0, r |= 0, n) || L(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
        var o = r - 1,
            i = 1;

        for (this[e + o] = 255 & t; --o >= 0 && (i *= 256);) {
          this[e + o] = t / i & 255;
        }

        return e + r;
      }, a.prototype.writeUInt8 = function (t, e, r) {
        return t = +t, e |= 0, r || L(this, t, e, 1, 255, 0), a.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), this[e] = 255 & t, e + 1;
      }, a.prototype.writeUInt16LE = function (t, e, r) {
        return t = +t, e |= 0, r || L(this, t, e, 2, 65535, 0), a.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : x(this, t, e, !0), e + 2;
      }, a.prototype.writeUInt16BE = function (t, e, r) {
        return t = +t, e |= 0, r || L(this, t, e, 2, 65535, 0), a.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : x(this, t, e, !1), e + 2;
      }, a.prototype.writeUInt32LE = function (t, e, r) {
        return t = +t, e |= 0, r || L(this, t, e, 4, 4294967295, 0), a.TYPED_ARRAY_SUPPORT ? (this[e + 3] = t >>> 24, this[e + 2] = t >>> 16, this[e + 1] = t >>> 8, this[e] = 255 & t) : C(this, t, e, !0), e + 4;
      }, a.prototype.writeUInt32BE = function (t, e, r) {
        return t = +t, e |= 0, r || L(this, t, e, 4, 4294967295, 0), a.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : C(this, t, e, !1), e + 4;
      }, a.prototype.writeIntLE = function (t, e, r, n) {
        if (t = +t, e |= 0, !n) {
          var o = Math.pow(2, 8 * r - 1);
          L(this, t, e, r, o - 1, -o);
        }

        var i = 0,
            s = 1,
            u = 0;

        for (this[e] = 255 & t; ++i < r && (s *= 256);) {
          t < 0 && 0 === u && 0 !== this[e + i - 1] && (u = 1), this[e + i] = (t / s >> 0) - u & 255;
        }

        return e + r;
      }, a.prototype.writeIntBE = function (t, e, r, n) {
        if (t = +t, e |= 0, !n) {
          var o = Math.pow(2, 8 * r - 1);
          L(this, t, e, r, o - 1, -o);
        }

        var i = r - 1,
            s = 1,
            u = 0;

        for (this[e + i] = 255 & t; --i >= 0 && (s *= 256);) {
          t < 0 && 0 === u && 0 !== this[e + i + 1] && (u = 1), this[e + i] = (t / s >> 0) - u & 255;
        }

        return e + r;
      }, a.prototype.writeInt8 = function (t, e, r) {
        return t = +t, e |= 0, r || L(this, t, e, 1, 127, -128), a.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), t < 0 && (t = 255 + t + 1), this[e] = 255 & t, e + 1;
      }, a.prototype.writeInt16LE = function (t, e, r) {
        return t = +t, e |= 0, r || L(this, t, e, 2, 32767, -32768), a.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : x(this, t, e, !0), e + 2;
      }, a.prototype.writeInt16BE = function (t, e, r) {
        return t = +t, e |= 0, r || L(this, t, e, 2, 32767, -32768), a.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : x(this, t, e, !1), e + 2;
      }, a.prototype.writeInt32LE = function (t, e, r) {
        return t = +t, e |= 0, r || L(this, t, e, 4, 2147483647, -2147483648), a.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8, this[e + 2] = t >>> 16, this[e + 3] = t >>> 24) : C(this, t, e, !0), e + 4;
      }, a.prototype.writeInt32BE = function (t, e, r) {
        return t = +t, e |= 0, r || L(this, t, e, 4, 2147483647, -2147483648), t < 0 && (t = 4294967295 + t + 1), a.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : C(this, t, e, !1), e + 4;
      }, a.prototype.writeFloatLE = function (t, e, r) {
        return k(this, t, e, !0, r);
      }, a.prototype.writeFloatBE = function (t, e, r) {
        return k(this, t, e, !1, r);
      }, a.prototype.writeDoubleLE = function (t, e, r) {
        return M(this, t, e, !0, r);
      }, a.prototype.writeDoubleBE = function (t, e, r) {
        return M(this, t, e, !1, r);
      }, a.prototype.copy = function (t, e, r, n) {
        if (r || (r = 0), n || 0 === n || (n = this.length), e >= t.length && (e = t.length), e || (e = 0), n > 0 && n < r && (n = r), n === r) return 0;
        if (0 === t.length || 0 === this.length) return 0;
        if (e < 0) throw new RangeError("targetStart out of bounds");
        if (r < 0 || r >= this.length) throw new RangeError("sourceStart out of bounds");
        if (n < 0) throw new RangeError("sourceEnd out of bounds");
        n > this.length && (n = this.length), t.length - e < n - r && (n = t.length - e + r);
        var o,
            i = n - r;
        if (this === t && r < e && e < n) for (o = i - 1; o >= 0; --o) {
          t[o + e] = this[o + r];
        } else if (i < 1e3 || !a.TYPED_ARRAY_SUPPORT) for (o = 0; o < i; ++o) {
          t[o + e] = this[o + r];
        } else Uint8Array.prototype.set.call(t, this.subarray(r, r + i), e);
        return i;
      }, a.prototype.fill = function (t, e, r, n) {
        if ("string" == typeof t) {
          if ("string" == typeof e ? (n = e, e = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), 1 === t.length) {
            var o = t.charCodeAt(0);
            o < 256 && (t = o);
          }

          if (void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
          if ("string" == typeof n && !a.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
        } else "number" == typeof t && (t &= 255);

        if (e < 0 || this.length < e || this.length < r) throw new RangeError("Out of range index");
        if (r <= e) return this;
        var i;
        if (e >>>= 0, r = void 0 === r ? this.length : r >>> 0, t || (t = 0), "number" == typeof t) for (i = e; i < r; ++i) {
          this[i] = t;
        } else {
          var s = a.isBuffer(t) ? t : q(new a(t, n).toString()),
              u = s.length;

          for (i = 0; i < r - e; ++i) {
            this[i + e] = s[i % u];
          }
        }
        return this;
      };
      var D = /[^+\/0-9A-Za-z-_]/g;

      function Y(t) {
        return t < 16 ? "0" + t.toString(16) : t.toString(16);
      }

      function q(t, e) {
        var r;
        e = e || 1 / 0;

        for (var n = t.length, o = null, i = [], s = 0; s < n; ++s) {
          if ((r = t.charCodeAt(s)) > 55295 && r < 57344) {
            if (!o) {
              if (r > 56319) {
                (e -= 3) > -1 && i.push(239, 191, 189);
                continue;
              }

              if (s + 1 === n) {
                (e -= 3) > -1 && i.push(239, 191, 189);
                continue;
              }

              o = r;
              continue;
            }

            if (r < 56320) {
              (e -= 3) > -1 && i.push(239, 191, 189), o = r;
              continue;
            }

            r = 65536 + (o - 55296 << 10 | r - 56320);
          } else o && (e -= 3) > -1 && i.push(239, 191, 189);

          if (o = null, r < 128) {
            if ((e -= 1) < 0) break;
            i.push(r);
          } else if (r < 2048) {
            if ((e -= 2) < 0) break;
            i.push(r >> 6 | 192, 63 & r | 128);
          } else if (r < 65536) {
            if ((e -= 3) < 0) break;
            i.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
          } else {
            if (!(r < 1114112)) throw new Error("Invalid code point");
            if ((e -= 4) < 0) break;
            i.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
          }
        }

        return i;
      }

      function V(t) {
        return n.toByteArray(function (t) {
          if ((t = function (t) {
            return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
          }(t).replace(D, "")).length < 2) return "";

          for (; t.length % 4 != 0;) {
            t += "=";
          }

          return t;
        }(t));
      }

      function F(t, e, r, n) {
        for (var o = 0; o < n && !(o + r >= e.length || o >= t.length); ++o) {
          e[o + r] = t[o];
        }

        return o;
      }
    }).call(this, r(5));
  }, function (t, e, r) {
    "use strict";

    (function (t) {
      r.d(e, "a", function () {
        return s;
      });
      var n = r(4),
          o = r.n(n),
          i = r(2);

      function s(_ref2) {
        var e = _ref2.name,
            r = _ref2.symbol,
            n = _ref2.decimals,
            s = _ref2.initialSupply,
            u = _ref2.tokenReceiverAddress,
            a = _ref2.batonReceiverAddress,
            f = _ref2.documentUri,
            c = _ref2.documentHash;
        if ("undefined" == typeof web4bch) return Promise.reject({
          type: "NO_PROVIDER"
        });
        if (!u) return Promise.reject({
          type: "MALFORMED_INPUT",
          description: "tokenReceiverAddress is a required field"
        });
        if (!Object(i.d)(u)) return Promise.reject({
          type: "MALFORMED_INPUT",
          description: "tokenReceiverAddress should be an slp address"
        });
        web4bch = new Web4Bch(web4bch.currentProvider);
        var h = new o.a(Number(s)).times(Math.pow(10, n)),
            l = Object(i.a)({
          ticker: r,
          name: e,
          documentUri: f,
          hash: null != c ? t.from(c, "utf-8") : null,
          decimals: Number(n),
          batonVout: a ? 2 : null,
          initialQuantity: h
        }),
            p = {
          from: web4bch.bch.defaultAccount,
          to: u,
          value: "546",
          opReturn: {
            data: l,
            isEncoded: !0,
            position: "0"
          }
        };
        return new Promise(function (t, e) {
          web4bch.bch.sendTransaction(p, function (r, n) {
            if (r) return e({
              type: "SEND_ERROR",
              data: r.message
            });
            t({
              tokenId: n
            });
          });
        });
      }
    }).call(this, r(6).Buffer);
  }, function (t, e, r) {
    t.exports = r(20);
  }, function (t, e, r) {
    "use strict";

    e.byteLength = function (t) {
      var e = f(t),
          r = e[0],
          n = e[1];
      return 3 * (r + n) / 4 - n;
    }, e.toByteArray = function (t) {
      var e,
          r,
          n = f(t),
          s = n[0],
          u = n[1],
          a = new i(function (t, e, r) {
        return 3 * (e + r) / 4 - r;
      }(0, s, u)),
          c = 0,
          h = u > 0 ? s - 4 : s;

      for (r = 0; r < h; r += 4) {
        e = o[t.charCodeAt(r)] << 18 | o[t.charCodeAt(r + 1)] << 12 | o[t.charCodeAt(r + 2)] << 6 | o[t.charCodeAt(r + 3)], a[c++] = e >> 16 & 255, a[c++] = e >> 8 & 255, a[c++] = 255 & e;
      }

      2 === u && (e = o[t.charCodeAt(r)] << 2 | o[t.charCodeAt(r + 1)] >> 4, a[c++] = 255 & e);
      1 === u && (e = o[t.charCodeAt(r)] << 10 | o[t.charCodeAt(r + 1)] << 4 | o[t.charCodeAt(r + 2)] >> 2, a[c++] = e >> 8 & 255, a[c++] = 255 & e);
      return a;
    }, e.fromByteArray = function (t) {
      for (var e, r = t.length, o = r % 3, i = [], s = 0, u = r - o; s < u; s += 16383) {
        i.push(c(t, s, s + 16383 > u ? u : s + 16383));
      }

      1 === o ? (e = t[r - 1], i.push(n[e >> 2] + n[e << 4 & 63] + "==")) : 2 === o && (e = (t[r - 2] << 8) + t[r - 1], i.push(n[e >> 10] + n[e >> 4 & 63] + n[e << 2 & 63] + "="));
      return i.join("");
    };

    for (var n = [], o = [], i = "undefined" != typeof Uint8Array ? Uint8Array : Array, s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", u = 0, a = s.length; u < a; ++u) {
      n[u] = s[u], o[s.charCodeAt(u)] = u;
    }

    function f(t) {
      var e = t.length;
      if (e % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
      var r = t.indexOf("=");
      return -1 === r && (r = e), [r, r === e ? 0 : 4 - r % 4];
    }

    function c(t, e, r) {
      for (var o, i, s = [], u = e; u < r; u += 3) {
        o = (t[u] << 16 & 16711680) + (t[u + 1] << 8 & 65280) + (255 & t[u + 2]), s.push(n[(i = o) >> 18 & 63] + n[i >> 12 & 63] + n[i >> 6 & 63] + n[63 & i]);
      }

      return s.join("");
    }

    o["-".charCodeAt(0)] = 62, o["_".charCodeAt(0)] = 63;
  }, function (t, e) {
    e.read = function (t, e, r, n, o) {
      var i,
          s,
          u = 8 * o - n - 1,
          a = (1 << u) - 1,
          f = a >> 1,
          c = -7,
          h = r ? o - 1 : 0,
          l = r ? -1 : 1,
          p = t[e + h];

      for (h += l, i = p & (1 << -c) - 1, p >>= -c, c += u; c > 0; i = 256 * i + t[e + h], h += l, c -= 8) {
        ;
      }

      for (s = i & (1 << -c) - 1, i >>= -c, c += n; c > 0; s = 256 * s + t[e + h], h += l, c -= 8) {
        ;
      }

      if (0 === i) i = 1 - f;else {
        if (i === a) return s ? NaN : 1 / 0 * (p ? -1 : 1);
        s += Math.pow(2, n), i -= f;
      }
      return (p ? -1 : 1) * s * Math.pow(2, i - n);
    }, e.write = function (t, e, r, n, o, i) {
      var s,
          u,
          a,
          f = 8 * i - o - 1,
          c = (1 << f) - 1,
          h = c >> 1,
          l = 23 === o ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
          p = n ? 0 : i - 1,
          d = n ? 1 : -1,
          g = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;

      for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (u = isNaN(e) ? 1 : 0, s = c) : (s = Math.floor(Math.log(e) / Math.LN2), e * (a = Math.pow(2, -s)) < 1 && (s--, a *= 2), (e += s + h >= 1 ? l / a : l * Math.pow(2, 1 - h)) * a >= 2 && (s++, a /= 2), s + h >= c ? (u = 0, s = c) : s + h >= 1 ? (u = (e * a - 1) * Math.pow(2, o), s += h) : (u = e * Math.pow(2, h - 1) * Math.pow(2, o), s = 0)); o >= 8; t[r + p] = 255 & u, p += d, u /= 256, o -= 8) {
        ;
      }

      for (s = s << o | u, f += o; f > 0; t[r + p] = 255 & s, p += d, s /= 256, f -= 8) {
        ;
      }

      t[r + p - d] |= 128 * g;
    };
  }, function (t, e) {
    var r = {}.toString;

    t.exports = Array.isArray || function (t) {
      return "[object Array]" == r.call(t);
    };
  }, function (t, e, r) {
    (function (e) {
      if (void 0 !== e.URL) t.exports = {
        makeUrlAbsolute: function makeUrlAbsolute(t, e) {
          return new URL(e, t).href;
        },
        parseUrl: function parseUrl(t) {
          return new URL(t).host;
        }
      };else {
        var _e8 = r(13);

        t.exports = {
          makeUrlAbsolute: function makeUrlAbsolute(t, r) {
            return null === _e8.parse(r).host ? _e8.resolve(t, r) : r;
          },
          parseUrl: function parseUrl(t) {
            return _e8.parse(t).hostname;
          }
        };
      }
    }).call(this, r(5));
  }, function (t, e, r) {
    "use strict";

    var n = r(14),
        o = r(16);

    function i() {
      this.protocol = null, this.slashes = null, this.auth = null, this.host = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.query = null, this.pathname = null, this.path = null, this.href = null;
    }

    e.parse = w, e.resolve = function (t, e) {
      return w(t, !1, !0).resolve(e);
    }, e.resolveObject = function (t, e) {
      return t ? w(t, !1, !0).resolveObject(e) : e;
    }, e.format = function (t) {
      o.isString(t) && (t = w(t));
      return t instanceof i ? t.format() : i.prototype.format.call(t);
    }, e.Url = i;
    var s = /^([a-z0-9.+-]+:)/i,
        u = /:[0-9]*$/,
        a = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,
        f = ["{", "}", "|", "\\", "^", "`"].concat(["<", ">", '"', "`", " ", "\r", "\n", "\t"]),
        c = ["'"].concat(f),
        h = ["%", "/", "?", ";", "#"].concat(c),
        l = ["/", "?", "#"],
        p = /^[+a-z0-9A-Z_-]{0,63}$/,
        d = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
        g = {
      javascript: !0,
      "javascript:": !0
    },
        m = {
      javascript: !0,
      "javascript:": !0
    },
        y = {
      http: !0,
      https: !0,
      ftp: !0,
      gopher: !0,
      file: !0,
      "http:": !0,
      "https:": !0,
      "ftp:": !0,
      "gopher:": !0,
      "file:": !0
    },
        b = r(17);

    function w(t, e, r) {
      if (t && o.isObject(t) && t instanceof i) return t;
      var n = new i();
      return n.parse(t, e, r), n;
    }

    i.prototype.parse = function (t, e, r) {
      if (!o.isString(t)) throw new TypeError("Parameter 'url' must be a string, not " + typeof t);
      var i = t.indexOf("?"),
          u = -1 !== i && i < t.indexOf("#") ? "?" : "#",
          f = t.split(u);
      f[0] = f[0].replace(/\\/g, "/");
      var w = t = f.join(u);

      if (w = w.trim(), !r && 1 === t.split("#").length) {
        var v = a.exec(w);
        if (v) return this.path = w, this.href = w, this.pathname = v[1], v[2] ? (this.search = v[2], this.query = e ? b.parse(this.search.substr(1)) : this.search.substr(1)) : e && (this.search = "", this.query = {}), this;
      }

      var A = s.exec(w);

      if (A) {
        var E = (A = A[0]).toLowerCase();
        this.protocol = E, w = w.substr(A.length);
      }

      if (r || A || w.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        var O = "//" === w.substr(0, 2);
        !O || A && m[A] || (w = w.substr(2), this.slashes = !0);
      }

      if (!m[A] && (O || A && !y[A])) {
        for (var R, P, _ = -1, B = 0; B < l.length; B++) {
          -1 !== (S = w.indexOf(l[B])) && (-1 === _ || S < _) && (_ = S);
        }

        -1 !== (P = -1 === _ ? w.lastIndexOf("@") : w.lastIndexOf("@", _)) && (R = w.slice(0, P), w = w.slice(P + 1), this.auth = decodeURIComponent(R)), _ = -1;

        for (B = 0; B < h.length; B++) {
          var S;
          -1 !== (S = w.indexOf(h[B])) && (-1 === _ || S < _) && (_ = S);
        }

        -1 === _ && (_ = w.length), this.host = w.slice(0, _), w = w.slice(_), this.parseHost(), this.hostname = this.hostname || "";
        var T = "[" === this.hostname[0] && "]" === this.hostname[this.hostname.length - 1];
        if (!T) for (var I = this.hostname.split(/\./), U = (B = 0, I.length); B < U; B++) {
          var N = I[B];

          if (N && !N.match(p)) {
            for (var L = "", x = 0, C = N.length; x < C; x++) {
              N.charCodeAt(x) > 127 ? L += "x" : L += N[x];
            }

            if (!L.match(p)) {
              var j = I.slice(0, B),
                  k = I.slice(B + 1),
                  M = N.match(d);
              M && (j.push(M[1]), k.unshift(M[2])), k.length && (w = "/" + k.join(".") + w), this.hostname = j.join(".");
              break;
            }
          }
        }
        this.hostname.length > 255 ? this.hostname = "" : this.hostname = this.hostname.toLowerCase(), T || (this.hostname = n.toASCII(this.hostname));
        var D = this.port ? ":" + this.port : "",
            Y = this.hostname || "";
        this.host = Y + D, this.href += this.host, T && (this.hostname = this.hostname.substr(1, this.hostname.length - 2), "/" !== w[0] && (w = "/" + w));
      }

      if (!g[E]) for (B = 0, U = c.length; B < U; B++) {
        var q = c[B];

        if (-1 !== w.indexOf(q)) {
          var V = encodeURIComponent(q);
          V === q && (V = escape(q)), w = w.split(q).join(V);
        }
      }
      var F = w.indexOf("#");
      -1 !== F && (this.hash = w.substr(F), w = w.slice(0, F));
      var H = w.indexOf("?");

      if (-1 !== H ? (this.search = w.substr(H), this.query = w.substr(H + 1), e && (this.query = b.parse(this.query)), w = w.slice(0, H)) : e && (this.search = "", this.query = {}), w && (this.pathname = w), y[E] && this.hostname && !this.pathname && (this.pathname = "/"), this.pathname || this.search) {
        D = this.pathname || "";
        var G = this.search || "";
        this.path = D + G;
      }

      return this.href = this.format(), this;
    }, i.prototype.format = function () {
      var t = this.auth || "";
      t && (t = (t = encodeURIComponent(t)).replace(/%3A/i, ":"), t += "@");
      var e = this.protocol || "",
          r = this.pathname || "",
          n = this.hash || "",
          i = !1,
          s = "";
      this.host ? i = t + this.host : this.hostname && (i = t + (-1 === this.hostname.indexOf(":") ? this.hostname : "[" + this.hostname + "]"), this.port && (i += ":" + this.port)), this.query && o.isObject(this.query) && Object.keys(this.query).length && (s = b.stringify(this.query));
      var u = this.search || s && "?" + s || "";
      return e && ":" !== e.substr(-1) && (e += ":"), this.slashes || (!e || y[e]) && !1 !== i ? (i = "//" + (i || ""), r && "/" !== r.charAt(0) && (r = "/" + r)) : i || (i = ""), n && "#" !== n.charAt(0) && (n = "#" + n), u && "?" !== u.charAt(0) && (u = "?" + u), e + i + (r = r.replace(/[?#]/g, function (t) {
        return encodeURIComponent(t);
      })) + (u = u.replace("#", "%23")) + n;
    }, i.prototype.resolve = function (t) {
      return this.resolveObject(w(t, !1, !0)).format();
    }, i.prototype.resolveObject = function (t) {
      if (o.isString(t)) {
        var e = new i();
        e.parse(t, !1, !0), t = e;
      }

      for (var r = new i(), n = Object.keys(this), s = 0; s < n.length; s++) {
        var u = n[s];
        r[u] = this[u];
      }

      if (r.hash = t.hash, "" === t.href) return r.href = r.format(), r;

      if (t.slashes && !t.protocol) {
        for (var a = Object.keys(t), f = 0; f < a.length; f++) {
          var c = a[f];
          "protocol" !== c && (r[c] = t[c]);
        }

        return y[r.protocol] && r.hostname && !r.pathname && (r.path = r.pathname = "/"), r.href = r.format(), r;
      }

      if (t.protocol && t.protocol !== r.protocol) {
        if (!y[t.protocol]) {
          for (var h = Object.keys(t), l = 0; l < h.length; l++) {
            var p = h[l];
            r[p] = t[p];
          }

          return r.href = r.format(), r;
        }

        if (r.protocol = t.protocol, t.host || m[t.protocol]) r.pathname = t.pathname;else {
          for (var d = (t.pathname || "").split("/"); d.length && !(t.host = d.shift());) {
            ;
          }

          t.host || (t.host = ""), t.hostname || (t.hostname = ""), "" !== d[0] && d.unshift(""), d.length < 2 && d.unshift(""), r.pathname = d.join("/");
        }

        if (r.search = t.search, r.query = t.query, r.host = t.host || "", r.auth = t.auth, r.hostname = t.hostname || t.host, r.port = t.port, r.pathname || r.search) {
          var g = r.pathname || "",
              b = r.search || "";
          r.path = g + b;
        }

        return r.slashes = r.slashes || t.slashes, r.href = r.format(), r;
      }

      var w = r.pathname && "/" === r.pathname.charAt(0),
          v = t.host || t.pathname && "/" === t.pathname.charAt(0),
          A = v || w || r.host && t.pathname,
          E = A,
          O = r.pathname && r.pathname.split("/") || [],
          R = (d = t.pathname && t.pathname.split("/") || [], r.protocol && !y[r.protocol]);
      if (R && (r.hostname = "", r.port = null, r.host && ("" === O[0] ? O[0] = r.host : O.unshift(r.host)), r.host = "", t.protocol && (t.hostname = null, t.port = null, t.host && ("" === d[0] ? d[0] = t.host : d.unshift(t.host)), t.host = null), A = A && ("" === d[0] || "" === O[0])), v) r.host = t.host || "" === t.host ? t.host : r.host, r.hostname = t.hostname || "" === t.hostname ? t.hostname : r.hostname, r.search = t.search, r.query = t.query, O = d;else if (d.length) O || (O = []), O.pop(), O = O.concat(d), r.search = t.search, r.query = t.query;else if (!o.isNullOrUndefined(t.search)) {
        if (R) r.hostname = r.host = O.shift(), (T = !!(r.host && r.host.indexOf("@") > 0) && r.host.split("@")) && (r.auth = T.shift(), r.host = r.hostname = T.shift());
        return r.search = t.search, r.query = t.query, o.isNull(r.pathname) && o.isNull(r.search) || (r.path = (r.pathname ? r.pathname : "") + (r.search ? r.search : "")), r.href = r.format(), r;
      }
      if (!O.length) return r.pathname = null, r.search ? r.path = "/" + r.search : r.path = null, r.href = r.format(), r;

      for (var P = O.slice(-1)[0], _ = (r.host || t.host || O.length > 1) && ("." === P || ".." === P) || "" === P, B = 0, S = O.length; S >= 0; S--) {
        "." === (P = O[S]) ? O.splice(S, 1) : ".." === P ? (O.splice(S, 1), B++) : B && (O.splice(S, 1), B--);
      }

      if (!A && !E) for (; B--; B) {
        O.unshift("..");
      }
      !A || "" === O[0] || O[0] && "/" === O[0].charAt(0) || O.unshift(""), _ && "/" !== O.join("/").substr(-1) && O.push("");
      var T,
          I = "" === O[0] || O[0] && "/" === O[0].charAt(0);
      R && (r.hostname = r.host = I ? "" : O.length ? O.shift() : "", (T = !!(r.host && r.host.indexOf("@") > 0) && r.host.split("@")) && (r.auth = T.shift(), r.host = r.hostname = T.shift()));
      return (A = A || r.host && O.length) && !I && O.unshift(""), O.length ? r.pathname = O.join("/") : (r.pathname = null, r.path = null), o.isNull(r.pathname) && o.isNull(r.search) || (r.path = (r.pathname ? r.pathname : "") + (r.search ? r.search : "")), r.auth = t.auth || r.auth, r.slashes = r.slashes || t.slashes, r.href = r.format(), r;
    }, i.prototype.parseHost = function () {
      var t = this.host,
          e = u.exec(t);
      e && (":" !== (e = e[0]) && (this.port = e.substr(1)), t = t.substr(0, t.length - e.length)), t && (this.hostname = t);
    };
  }, function (t, e, r) {
    (function (t, n) {
      var o;
      /*! https://mths.be/punycode v1.4.1 by @mathias */

      !function (i) {
        e && e.nodeType, t && t.nodeType;
        var s = "object" == typeof n && n;
        s.global !== s && s.window !== s && s.self;
        var u,
            a = 2147483647,
            f = 36,
            c = 1,
            h = 26,
            l = 38,
            p = 700,
            d = 72,
            g = 128,
            m = "-",
            y = /^xn--/,
            b = /[^\x20-\x7E]/,
            w = /[\x2E\u3002\uFF0E\uFF61]/g,
            v = {
          overflow: "Overflow: input needs wider integers to process",
          "not-basic": "Illegal input >= 0x80 (not a basic code point)",
          "invalid-input": "Invalid input"
        },
            A = f - c,
            E = Math.floor,
            O = String.fromCharCode;

        function R(t) {
          throw new RangeError(v[t]);
        }

        function P(t, e) {
          for (var r = t.length, n = []; r--;) {
            n[r] = e(t[r]);
          }

          return n;
        }

        function _(t, e) {
          var r = t.split("@"),
              n = "";
          return r.length > 1 && (n = r[0] + "@", t = r[1]), n + P((t = t.replace(w, ".")).split("."), e).join(".");
        }

        function B(t) {
          for (var e, r, n = [], o = 0, i = t.length; o < i;) {
            (e = t.charCodeAt(o++)) >= 55296 && e <= 56319 && o < i ? 56320 == (64512 & (r = t.charCodeAt(o++))) ? n.push(((1023 & e) << 10) + (1023 & r) + 65536) : (n.push(e), o--) : n.push(e);
          }

          return n;
        }

        function S(t) {
          return P(t, function (t) {
            var e = "";
            return t > 65535 && (e += O((t -= 65536) >>> 10 & 1023 | 55296), t = 56320 | 1023 & t), e += O(t);
          }).join("");
        }

        function T(t, e) {
          return t + 22 + 75 * (t < 26) - ((0 != e) << 5);
        }

        function I(t, e, r) {
          var n = 0;

          for (t = r ? E(t / p) : t >> 1, t += E(t / e); t > A * h >> 1; n += f) {
            t = E(t / A);
          }

          return E(n + (A + 1) * t / (t + l));
        }

        function U(t) {
          var e,
              r,
              n,
              o,
              i,
              s,
              u,
              l,
              p,
              y,
              b,
              w = [],
              v = t.length,
              A = 0,
              O = g,
              P = d;

          for ((r = t.lastIndexOf(m)) < 0 && (r = 0), n = 0; n < r; ++n) {
            t.charCodeAt(n) >= 128 && R("not-basic"), w.push(t.charCodeAt(n));
          }

          for (o = r > 0 ? r + 1 : 0; o < v;) {
            for (i = A, s = 1, u = f; o >= v && R("invalid-input"), ((l = (b = t.charCodeAt(o++)) - 48 < 10 ? b - 22 : b - 65 < 26 ? b - 65 : b - 97 < 26 ? b - 97 : f) >= f || l > E((a - A) / s)) && R("overflow"), A += l * s, !(l < (p = u <= P ? c : u >= P + h ? h : u - P)); u += f) {
              s > E(a / (y = f - p)) && R("overflow"), s *= y;
            }

            P = I(A - i, e = w.length + 1, 0 == i), E(A / e) > a - O && R("overflow"), O += E(A / e), A %= e, w.splice(A++, 0, O);
          }

          return S(w);
        }

        function N(t) {
          var e,
              r,
              n,
              o,
              i,
              s,
              u,
              l,
              p,
              y,
              b,
              w,
              v,
              A,
              P,
              _ = [];

          for (w = (t = B(t)).length, e = g, r = 0, i = d, s = 0; s < w; ++s) {
            (b = t[s]) < 128 && _.push(O(b));
          }

          for (n = o = _.length, o && _.push(m); n < w;) {
            for (u = a, s = 0; s < w; ++s) {
              (b = t[s]) >= e && b < u && (u = b);
            }

            for (u - e > E((a - r) / (v = n + 1)) && R("overflow"), r += (u - e) * v, e = u, s = 0; s < w; ++s) {
              if ((b = t[s]) < e && ++r > a && R("overflow"), b == e) {
                for (l = r, p = f; !(l < (y = p <= i ? c : p >= i + h ? h : p - i)); p += f) {
                  P = l - y, A = f - y, _.push(O(T(y + P % A, 0))), l = E(P / A);
                }

                _.push(O(T(l, 0))), i = I(r, v, n == o), r = 0, ++n;
              }
            }

            ++r, ++e;
          }

          return _.join("");
        }

        u = {
          version: "1.4.1",
          ucs2: {
            decode: B,
            encode: S
          },
          decode: U,
          encode: N,
          toASCII: function toASCII(t) {
            return _(t, function (t) {
              return b.test(t) ? "xn--" + N(t) : t;
            });
          },
          toUnicode: function toUnicode(t) {
            return _(t, function (t) {
              return y.test(t) ? U(t.slice(4).toLowerCase()) : t;
            });
          }
        }, void 0 === (o = function () {
          return u;
        }.call(e, r, e, t)) || (t.exports = o);
      }();
    }).call(this, r(15)(t), r(5));
  }, function (t, e) {
    t.exports = function (t) {
      return t.webpackPolyfill || (t.deprecate = function () {}, t.paths = [], t.children || (t.children = []), Object.defineProperty(t, "loaded", {
        enumerable: !0,
        get: function get() {
          return t.l;
        }
      }), Object.defineProperty(t, "id", {
        enumerable: !0,
        get: function get() {
          return t.i;
        }
      }), t.webpackPolyfill = 1), t;
    };
  }, function (t, e, r) {
    "use strict";

    t.exports = {
      isString: function isString(t) {
        return "string" == typeof t;
      },
      isObject: function isObject(t) {
        return "object" == typeof t && null !== t;
      },
      isNull: function isNull(t) {
        return null === t;
      },
      isNullOrUndefined: function isNullOrUndefined(t) {
        return null == t;
      }
    };
  }, function (t, e, r) {
    "use strict";

    e.decode = e.parse = r(18), e.encode = e.stringify = r(19);
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }

    t.exports = function (t, e, r, i) {
      e = e || "&", r = r || "=";
      var s = {};
      if ("string" != typeof t || 0 === t.length) return s;
      var u = /\+/g;
      t = t.split(e);
      var a = 1e3;
      i && "number" == typeof i.maxKeys && (a = i.maxKeys);
      var f = t.length;
      a > 0 && f > a && (f = a);

      for (var c = 0; c < f; ++c) {
        var h,
            l,
            p,
            d,
            g = t[c].replace(u, "%20"),
            m = g.indexOf(r);
        m >= 0 ? (h = g.substr(0, m), l = g.substr(m + 1)) : (h = g, l = ""), p = decodeURIComponent(h), d = decodeURIComponent(l), n(s, p) ? o(s[p]) ? s[p].push(d) : s[p] = [s[p], d] : s[p] = d;
      }

      return s;
    };

    var o = Array.isArray || function (t) {
      return "[object Array]" === Object.prototype.toString.call(t);
    };
  }, function (t, e, r) {
    "use strict";

    var n = function n(t) {
      switch (typeof t) {
        case "string":
          return t;

        case "boolean":
          return t ? "true" : "false";

        case "number":
          return isFinite(t) ? t : "";

        default:
          return "";
      }
    };

    t.exports = function (t, e, r, u) {
      return e = e || "&", r = r || "=", null === t && (t = void 0), "object" == typeof t ? i(s(t), function (s) {
        var u = encodeURIComponent(n(s)) + r;
        return o(t[s]) ? i(t[s], function (t) {
          return u + encodeURIComponent(n(t));
        }).join(e) : u + encodeURIComponent(n(t[s]));
      }).join(e) : u ? encodeURIComponent(n(u)) + r + encodeURIComponent(n(t)) : "";
    };

    var o = Array.isArray || function (t) {
      return "[object Array]" === Object.prototype.toString.call(t);
    };

    function i(t, e) {
      if (t.map) return t.map(e);

      for (var r = [], n = 0; n < t.length; n++) {
        r.push(e(t[n], n));
      }

      return r;
    }

    var s = Object.keys || function (t) {
      var e = [];

      for (var r in t) {
        Object.prototype.hasOwnProperty.call(t, r) && e.push(r);
      }

      return e;
    };
  }, function (t, e, r) {
    "use strict";

    var n;
    r.r(e), function (t) {
      t.BCH = "BCH", t.SLP = "SLP", t.BTC = "BTC";
    }(n || (n = {}));
    var o,
        i = r(2);
    !function (t) {
      t.BCH = "BCH", t.SLP = "SLP", t.BTC = "BTC";
    }(o || (o = {}));
    var s = r(7),
        u = r(0);

    function a() {
      return "undefined" != typeof web4bch;
    }

    function f() {
      return "undefined" == typeof web4bch ? u.d.NOT_AVAILABLE : a() && (web4bch = new Web4Bch(web4bch.currentProvider), Boolean(web4bch.bch.defaultAccount)) ? u.d.LOGGED_IN : u.d.AVAILABLE;
    }

    var c,
        h,
        l = {
      getAddress: function getAddress(_ref3) {
        var t = _ref3.protocol;
        if ("undefined" == typeof web4bch) return Promise.reject({
          type: "NO_PROVIDER"
        });
        var e;

        switch (web4bch = new Web4Bch(web4bch.currentProvider), t) {
          case n.BCH:
            e = web4bch.bch.defaultAccount;
            break;

          case n.SLP:
            e = web4bch.bch.defaultSlpAccount;
            break;

          default:
            return Promise.reject({
              type: "PROTOCOL_ERROR",
              description: "The provided protocol is not supported by this wallet."
            });
        }

        return e ? Promise.resolve({
          address: e
        }) : Promise.reject({
          type: "CONNECTION_DENIED",
          description: "User not logged into wallet."
        });
      },
      sendAssets: function sendAssets(_ref4) {
        var t = _ref4.to,
            e = _ref4.protocol,
            r = _ref4.value,
            n = _ref4.assetId,
            s = _ref4.opReturn;
        if ("undefined" == typeof web4bch) return Promise.reject({
          type: "NO_PROVIDER"
        });
        web4bch = new Web4Bch(web4bch.currentProvider);
        var u = {
          to: t,
          from: web4bch.bch.defaultAccount
        };

        switch (e) {
          case o.BCH:
            u.value = Object(i.b)(r, 8).toString();
            break;

          case o.SLP:
            u.value = r, u.sendTokenData = {
              tokenId: n,
              tokenProtocol: "slp"
            };
            break;

          default:
            return Promise.reject({
              type: "PROTOCOL_ERROR",
              description: "The provided protocol is not supported by this wallet."
            });
        }

        return s && (u.opReturn = {
          data: s
        }), new Promise(function (t, e) {
          web4bch.bch.sendTransaction(u, function (r, n) {
            if (r) return r.message.includes("User denied transaction signature") ? e({
              type: "CANCELED",
              data: r.message
            }) : e({
              type: "SEND_ERROR",
              data: r.message
            });
            t({
              txid: n
            });
          });
        });
      },
      payInvoice: function payInvoice(_ref5) {
        var t = _ref5.url;
        if ("undefined" == typeof web4bch) return Promise.reject({
          type: "NO_PROVIDER"
        });
        web4bch = new Web4Bch(web4bch.currentProvider);
        var e = {
          paymentRequestUrl: t
        };
        return new Promise(function (t, r) {
          web4bch.bch.sendTransaction(e, function (e, n) {
            if (e) return r({
              type: "SEND_ERROR",
              data: e.message
            });
            t({
              memo: n
            });
          });
        });
      },
      createToken: s.a
    },
        p = r(1);
    !function (t) {
      t.BCH = "BCH", t.SLP = "SLP", t.BTC = "BTC";
    }(c || (c = {})), function (t) {
      t.BCH = "BCH", t.SLP = "SLP", t.BTC = "BTC";
    }(h || (h = {}));
    var d = {
      getAddress: function getAddress(t) {
        return Object(p.d)({
          command: u.a.getAddress,
          data: t
        });
      },
      sendAssets: function sendAssets(t) {
        return Object(p.d)({
          command: u.a.sendAssets,
          data: t
        });
      },
      payInvoice: function payInvoice(t) {
        return Object(p.d)({
          command: u.a.payInvoice,
          data: t
        });
      },
      createToken: function createToken(t) {
        return Object(p.d)({
          command: u.a.createToken,
          data: t
        });
      }
    };
    var g = Object.keys(u.a).filter(function (t) {
      return "number" != typeof t;
    }).reduce(function (t, e) {
      return t[e] = function (t) {
        return function (e) {
          return a() ? l[t](e) : Object(p.c)() ? d[t](e) : Promise.reject({
            type: "NO_PROVIDER"
          });
        };
      }(e), t;
    }, {});
    e["default"] = Object.assign(Object.assign({}, g), {
      getWalletProviderStatus: function getWalletProviderStatus() {
        return {
          badger: f(),
          android: Object(p.a)() ? u.d.AVAILABLE : u.d.NOT_AVAILABLE,
          ios: Object(p.b)() ? u.d.AVAILABLE : u.d.NOT_AVAILABLE
        };
      },
      constants: {
        WalletProviderStatus: u.d
      }
    });
  }])["default"];
});